<template>
  <div class="containerForm" v-loading="formDataloading">
    <div class="head flex items-center">
      <i class="el-icon-document fileIcon"></i>
      <p class="font-bold">{{ $t("table.BargingInformation") }}</p>
    </div>
    <div class="form">
      <el-form ref="elForm" :model="formData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
        label-position="left" :disabled="fromdisabled">
        <el-form-item :label="'ID :'" prop="id">
          <el-input :disabled="true || !isCustomerAdmin" v-model="formData.id">
          </el-input>
        </el-form-item>
        <template v-if="isLogistic">
          <el-form ref="elCustomCodeForm" :model="formData" :rules="rules" size="small"
            :label-width="isMobileScreen ? null : '200px'" label-position="left" :disabled="elCustomCode">
            <el-form-item label="Custom Code:" prop="customCode">
              <el-select size="small" v-model="formData.customCode" placeholder="Select custom code" clearable
                :disabled="!allowEditCustomCode" @change="handleUpdateCustomCode" style="width: 100%;">
                <el-option v-for="(option, index) in customCodeOptions" :key="index" :label="option.label"
                  :value="option.value" />
              </el-select>
            </el-form-item>
          </el-form>
        </template>
        <el-form-item :label="$t('table.customer') + ':'" prop="customerCompanyName">
          <el-input :disabled="true" v-model="formData.customerCompanyName">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('table.ETA') + ':'" prop="noEta">
          <el-date-picker v-model="formData.noEtas" :picker-options="pickerOptions" prefix-icon="el-icon-date"
            type="datetime" :style="{ width: '100%' }" format="dd/MM/yyyy HH:mm:ss" value-format="dd/MM/yyyy HH:mm:ss"
            @change="Timehangder" :disabled="!isCustomerAdmin">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('table.barge') + ':'" prop="bargeName">
          <el-select v-model="formData.bargeName" clearable placeholder="Type here to search..." filterable
            bargeNameloading remote :remote-method="handleSearchBarge" class="bargeNameinput" @change="imochange"
            :loading="isBargeOptionsLoading" :disabled="allowChangeBarge() || !isCustomerAdmin" v-cancel-read-only>
            <!-- <el-option v-for="item in bargeoptions" :key="item.value" :disabled="item.unFlag == 1 || (item.requestStatus || '').toLowerCase() !== 'accepted'"
              :value="item.imo">
              <div style="display: flex; justify-content: space-between; width: 100%;">
                <span>{{ item.bargeName ? `${item.imo} (${item.bargeName})` : item.imo }}</span>
                <span :style="{ marginLeft: 'auto', color: (item.requestStatus || '').toLowerCase() === 'accepted' ? 'green' : 'gray' }">{{ item.requestStatus }}</span>
              </div>
            </el-option> -->
            <el-option v-for="item in bargeoptions" :key="item.value" :disabled="item.unFlag == 1"
              :label="item.bargeName ? `${item.imo} (${item.bargeName})` : `${item.imo}`" :value="item.imo">
            </el-option>
          </el-select>
          <div v-if="mvpCompanyData"
            style="position: absolute; top: 0; right: 7px; display: flex; align-items: center; height: 100%">
            <img width="25" :src="iconOnlyImg" :title="'Company name: ' + mvpCompanyData.name" />
          </div>
        </el-form-item>
        <div v-if="showBargeNotAccepted"
          style="color: #FF5C00; margin-left: 200px; margin-bottom: 10px; font-size: 12px;">Barge
          is not accepted yet</div>
        <!-- <el-form-item :label="$t('table.contact') + ':'" prop="contact">
          <el-input v-model="formData.contact" clearable size="small" :style="{ width: '100%' }"></el-input>
        </el-form-item> -->
        <el-form-item label="Nominated Qty Max:" prop="nominatedQtyMax">
          <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
            <div class="flex w-full">
              <el-input ref="qtys" oninput="value=value.replace(/[^\d]/g,'')" v-model="formData.nominatedQtyMax"
                clearable size="small" :style="{ width: '100%' }" :disabled="!isCustomerAdmin">
                <div slot="append">MT</div>
              </el-input>
            </div>
            <div class="flex" v-if="allowToChangeQuantity"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeQuantityDialog">Change
                Quantity</el-button>
            </div>
          </div>
          <div v-if="formData.qtyRequestStatus" style="color:#FF5C00; font-size:11px">Requested to change quantity to {{
            formData.newNominatedQtyMax }} MT </div>
        </el-form-item>

        <el-form-item :label="$t('table.BalanceTank') + ':'" prop="balanceInTank">
          <el-input ref="Tanks" oninput="value=value.replace(/[^\d]/g,'')" v-model.number="formData.balanceInTank"
            clearable size="small" :style="{ width: '100%' }" :disabled="!isCustomerAdmin">
            <div slot="append">MT</div>
          </el-input>
        </el-form-item>

        <!-- <el-form-item :label="$t('table.tanks') + ':'" prop="tlist">
          <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
            <div class="flex w-full">
              <el-select multiple v-model="formData.tlist" placeholder="" clearable size="small"
                :style="{ width: '100%' }" :disabled="!isCustomerAdmin" @change="recomputePriorityStatus">
                <el-option v-for="(item) in tankOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="flex" v-if="allowToChangeTank" v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeTankDialog">Change
                Tank(s)</el-button>
            </div>
          </div>
          <div v-if="formData.tankRequestStatus" style="color:#FF5C00; font-size:11px">
            Requested to change tank(s) to {{ formData.newTank }}
          </div>
        </el-form-item> -->

        <el-form-item :label="$t('table.tanks') + ':'" prop="tlist">
          <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
            <div class="flex w-full">
              <el-select multiple v-model="formData.tlist" placeholder="" clearable size="small"
                :style="{ width: '100%' }" :disabled="!isCustomerAdmin" @change="recomputePriorityStatus">
                <el-option v-for="(item) in tankOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="flex" v-if="allowToChangeTank"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeTankDialog">Change
                Tank(s)</el-button>
            </div>
          </div>
          <div v-if="formData.tankRequestStatus" style="color:#FF5C00; font-size:11px">
            Requested to change tank(s) to {{ formData.newTank }}
          </div>
        </el-form-item>

        <!-- <el-form-item :label="$t('table.tanks') + ':'" prop="tlist">
          <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
            <div class="flex w-full">
              <el-select multiple v-model="formData.tlist" placeholder="" clearable size="small"
                :style="{ width: '100%' }" :disabled="!isCustomerAdmin" @change="recomputePriorityStatus">
                <el-option v-for="(item) in tankOptions.filter(i => !i.disabled)" :key="item.value" :value="item.value"
                  :label="item.label">
                  <div class="option-content">
                    <span class="option-left">{{ item.label }}</span>
                    <span class="option-right">{{ item.dateSuffix }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="flex" v-if="allowToChangeTank"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeTankDialog">Change
                Tank(s)</el-button>
            </div>
          </div>
          <div v-if="formData.tankRequestStatus" style="color:#FF5C00; font-size:11px">
            Requested to change tank(s) to {{ formData.newTank }}
          </div>
        </el-form-item> -->

        <el-form-item :label="$t('table.product') + ':'" prop="product">
          <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
            <div class="flex w-full">
              <el-select size="small" v-model="formData.product" placeholder="" clearable :style="{ width: '100%' }"
                :disabled="!isCustomerAdmin">
                <el-option v-for="(item, index) in productOptions" :key="index" :label="item.label" :value="item.value"
                  :disabled="item.disabled"></el-option>
              </el-select>
            </div>
            <div class="flex" v-if="allowToChangeProduct"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeProductDialog">Change
                Product</el-button>
            </div>
          </div>
          <div v-if="formData.productRequestStatus" style="color:#FF5C00; font-size:11px">
            Requested to change product to {{ formData.newProduct }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('table.surveyors') + ':'" prop="slist">
          <!--  v-model="formData.surveyor"   formData.slist -->
          <el-select size="small" v-model="formData.slist" multiple placeholder="" :style="{ width: '100%' }"
            :disabled="!isCustomerAdmin">
            <el-option v-for="(item) in surveyorOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.doc') + ':'" prop="doc">
          <div class="flex justify-between" v-bind:class="{ 'flex-col': isMobileScreen }">
            <div class="flex w-full">
              <el-select size="small" v-model="formData.doc" placeholder="" clearable :style="{ width: '100%' }"
                :disabled="!isCustomerAdmin">
                <el-option v-for="(item, index) in docOptions" :key="index" :label="item.label" :value="item.value"
                  :disabled="item.disabled"></el-option>
              </el-select>
            </div>
            <div class="flex" v-if="allowToChangeDoc"
              v-bind:class="{ 'pt-1': isMobileScreen, 'pl-2': !isMobileScreen }">
              <el-button size="mini" type="primary" plain :disabled="false" @click="openChangeDocDialog">Change
                Doc</el-button>
            </div>
          </div>
          <div v-if="formData.docRequestStatus" style="color:#FF5C00; font-size:11px">Requested to change doc to {{
            formData.newDoc }}</div>
        </el-form-item>
        <el-form-item :label="$t('table.block') + ':'" prop="blockNomination">
          <el-switch size="small" v-model="formData.blockNomination" active-value="1" inactive-value="0"
            :disabled="!isCustomerAdmin"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('table.remarks') + ':'" prop="remarks">
          <el-input size="small" v-model="formData.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }"
            :style="{ width: '100%' }" :disabled="!isCustomerAdmin"></el-input>
        </el-form-item>
        <el-form-item :label="$t('table.hideFromTerminal') + ':'"
          v-if="(userInfo.userType == 2 || userInfo.role == 5) && (Object.keys(createdtable).length < 1 || (createdtable.status == 0 || createdtable.status == 1))"
          class="formItemHideFromTerminal">
          <el-switch size="small" v-model="formData.hideFromTerminal" active-value="1" inactive-value="0"
            :disabled="!isCustomerAdmin"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="information">
      <div class="flex head">
        <svg-icon iconClass="boat-two" />
        <p class="title font-bold">{{ $t("table.Opeinfo") }} </p>
      </div>
      <div class="mt-2">
        <el-form ref="elOperationForm" :model="operationData" :rules="rules" size="small"
          :label-width="isMobileScreen ? null : '200px'" label-position="left" :disabled="elvisible">
          <el-form-item :label="$t('table.bargeReadiness') + ':'" prop="bargeReadinesss">
            <el-date-picker v-model="operationData.bargeReadiness" :picker-options="pickerOptions" type="datetime"
              prefix-icon="el-icon-date" :style="{ width: '100%' }" format="dd/MM/yyyy  HH:mm:ss"
              value-format="dd/MM/yyyy HH:mm:ss" size="small" @change="Timehangder">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('table.typeofPilot') + ':'" prop="typeOfPilot" class="typeOfPilot">
            <el-select v-model="operationData.typeOfPilot" placeholder="" clearable size="small"
              :style="{ width: '100%' }" @change="typeOfPilotChange(operationData.typeOfPilot)">
              <el-option v-for="(item, index) in pilotOptions" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <span class="text" v-if="textvalidate" v-show="formData.blockNomination == '1' ? false : true">
              <p class="textb">
                Please ensure that the master is pilot exempted and that the barge LOA is below 122 meter. Please
                produce
                a pilot exemption certificate when asked to.
              </p>
            </span>
          </el-form-item>
          <el-form-item v-if="contactdisabled" :label="$t('table.psacontactnumber') + ':'" prop="contactNumber">
            <vue-tel-input :disabled="elvisible" v-model="operationData.contactNumber" mode="international"
              :style="{ width: '100%' }" @input="onPSAContactNumberChange" required disabledFormatting
              validCharactersOnly></vue-tel-input>
            <div style="color: #f56c6c; font-size: 12px" v-if="PSAContactNumberIsValid == false">The contact number
              provided
              is invalid</div>
          </el-form-item>
          <el-form-item :label="$t('table.contactnumber') + ':'">
            <div v-for="(item, index) in bargeContactNumbers" :key="'contact-' + index" style="position: relative;">
              <vue-tel-input v-model="item.contactNumber" mode="international"
                @input="(number, phoneObject) => onContactNumberChange(item, phoneObject)" :disabled="elvisible"
                required disabledFormatting validCharactersOnly></vue-tel-input>
              <el-link v-if="!elvisible" type="danger" style="position: absolute; right: 8px; top: -1px"
                @click="onContactNumberRemove(index)">Remove</el-link>
              <div style="color: #f56c6c; font-size: 12px" v-if="item.phoneNumberIsValid == false">The contact number
                provided is invalid</div>
            </div>
            <div v-if="!elvisible" style="display: flex; justify-content: flex-end; cursor: pointer;"
              @click="addMoreContactNumber">
              <div
                style="display: flex; flex-direction: row; align-items: center; gap: 5px; padding-top: 4px; color: #82889c;">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px"></i>
                <div>Click here to add more contact number</div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div :class="!textvalidate ? 'information' : 'mt-16'">
      <div class="flex head">
        <i class="el-icon-location-outline fileIcon"></i>
        <p class="title font-bold">{{ $t("table.jettyInformation") }} </p>
      </div>
      <div class="mt-2">
        <el-form :model="coLoadData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
          label-position="left" :disabled="coLoadDataVisible">
          <el-form-item label="Co-Load:">
            <el-select v-model="coLoadData.coLoad" clearable size="small" :style="{ width: '100%' }"
              @change="handleCoLoadChange">
              <el-option v-for="opt in coLoadOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
          </el-form-item>

          <div v-if="coLoadData.coLoad === 1"
            style="border: #add4ed 1px solid; background-color: #f0f6ff; margin-left: 200px; border-radius: 4px"
            class="p-2 my-2">
            <span style="color: #4865ba; font-size: 11px;"><i class="el-icon-info"
                style="color: #409EFF; margin-right: 5px; font-size: 16px;"></i>When co-loading, the <span
                class="font-bold">ETA</span>
              will
              automatically sync to the nomination with the higher <span class="font-bold">Nominated Qty
                Max</span></span>
          </div>

          <el-form-item v-if="coLoadData.coLoad === 1 && selectedCoLoadList.length == 0">
            <v-select v-model="tempSelectedCoLoadKeys" :options="coLoadNominationOptions" :multiple="true"
              :close-on-select="false" :reduce="opt => opt.value" label="label"
              placeholder="Select nomination(s) to co-load with" @search:focus="onCoLoadDropdownVisibleChange(true)"
              @search:blur="onCoLoadDropdownVisibleChange(false)">
              <!-- option slot: some versions pass (opt), some pass ({ option }) -->
              <template #option="slot">
                <div class="coLoadOptionBlock"
                  :style="{ borderLeftColor: getOptionDotColor(slot.option || slot), borderLeftWidth: '4px', borderLeftStyle: 'solid', paddingLeft: '8px' }">
                  {{ (slot.option || slot).displayLabel || (slot.option || slot).label }}
                </div>
              </template>

              <template #selected-option="slot">
                <div class="coLoadSelectedBlock">
                  {{ (slot.option || slot).label }}
                </div>
              </template>
            </v-select>
          </el-form-item>
        </el-form>

        <div v-if="selectedCoLoadList.length > 0"
          style="border: #ebecf1 1px solid; background-color: #f8f9fb; margin-left: 200px; border-radius: 4px;"
          class="p-2 my-2">
          <div class="justify-between flex w-full"><span style="color: grey; font-size: 12px;"><i class="el-icon-time"
                style="color: #409EFF; margin-right: 5px; font-size: 16px;"></i>Co-Loading with {{
                  selectedCoLoadList.length }} nomination<span
                v-if="selectedCoLoadList.length > 1">s</span></span><el-button size="mini" type="primary" plain
              :disabled="coLoadDataVisible" @click="onReSelectCoLoad">
              Re-select
            </el-button></div>

          <div v-for="coLoad in selectedCoLoadList"
            style="color:#578197; border: #5babde 1px solid; border-radius: 4px; background-color: white; flex-wrap: wrap; font-size: 12px;"
            class="px-1 py-2 my-2">
            {{ coLoad.id + " • " + coLoad.vesselName + " • " + coLoad.nominatedQtyMax + " • " + coLoad.noEta, }}
          </div>
        </div>

        <el-form :model="formData" size="small" :label-width="isMobileScreen ? null : '200px'" label-position="left"
          v-if="isLogistic">
          <el-form-item label="Priority Status:">
            <el-select v-model="formData.priorityStatus" placeholder="Select" clearable size="small"
              :style="{ width: '100%' }" :disabled="!allowEditPriorityStatus" @change="handleUpdatePriorityStatus">
              <el-option v-for="opt in priorityStatusOptions" :key="opt.value" :label="opt.label"
                :value="Number(opt.value)" :disabled="isLogistic && (opt.value === 1 || opt.value === 2)" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-form ref="elinformaForm" :model="elinformaData" :rules="rules" size="small"
          :label-width="isMobileScreen ? null : '200px'" label-position="left" :disabled="Jettyelvisible">

          <el-form :model="elinformaData" :rules="rules" size="small" :label-width="isMobileScreen ? null : '200px'"
            label-position="left" :disabled="estimatedBerthTimingDisabled">
            <el-form-item :label="$t('table.estimatedBerthTiming') + ':'" prop="estimatedBerthTimings">
              <el-date-picker v-show="formData.blockNomination == '1' ? false : true"
                v-model="elinformaData.estimatedBerthTimings" prefix-icon="el-icon-date" format="dd/MM/yyyy HH:mm:ss"
                value-format="dd/MM/yyyy HH:mm:ss" type="datetime" :style="{ width: '100%' }"
                @change="onEstimatedBerthTimingChange">
              </el-date-picker>
            </el-form-item>
          </el-form>

          <el-form-item :label="$t('table.jettyNo') + ':'" prop="bargeReadiness">
            <el-select v-show="formData.blockNomination == '1' ? false : true" v-model="elinformaData.jettyNo" clearable
              placeholder="" size="small" :style="{ width: '100%' }" @change="onJettyNoChange">
              <el-option v-for="(item, index) in jettyNoOptios" :key="index" :label="item.berthName"
                :value="item.berthName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('table.berthAssignTiming') + ':'" prop="berthAssignTimings">
            <el-date-picker v-show="formData.blockNomination == '1' ? false : true"
              v-model="elinformaData.berthAssignTimings" prefix-icon="el-icon-date" format="dd/MM/yyyy HH:mm:ss"
              value-format="dd/MM/yyyy HH:mm:ss" type="datetime" :style="{ width: '100%' }" @change="Timehangder">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="information">
      <div class="flex head">
        <i class="el-icon-ship fileIcon"></i>
        <p class="title font-bold">Fresh Water </p>
      </div>
      <div class="mt-2">
        <el-form ref="elFreshWaterForm" :model="elFreshWaterData" :rules="rules" size="small"
          :label-width="isMobileScreen ? null : '200px'" label-position="left">
          <el-form-item label="Fresh Water:" prop="freshWater">
            <el-switch v-model="elFreshWaterData.freshWater" :disabled="allowEditFreshWater" />
          </el-form-item>
          <el-form-item label="Fresh Water Available:" prop="freshWaterAvailable">
            <el-select v-model="elFreshWaterData.freshWaterAvailable" @change="updateWaterInput" placeholder="Select"
              size="mini" :style="{ width: '100%' }" :disabled="allowEditFreshWaterAvailable">
              <el-option v-for="item in freshWaterAvailableOptions" :key="item.id" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="Water Voucher:" prop="waterVoucher">
            <el-input v-model="elFreshWaterData.waterVoucher" :disabled="allowEditWaterVoucher" />
          </el-form-item>
          <el-form-item label="Water Meter:" prop="waterMeter">
            <el-input v-model="elFreshWaterData.waterMeter" :disabled="allowEditWaterVoucher" />
          </el-form-item>

        </el-form>
      </div>
    </div>
    <success-dialog v-on="$listeners" ref="successDialog" @upup="upup" />
    <checkBargeDialog ref="checkBargeDialog" @confirm="handleSureConfirm" :message="message"
      :isMobileScreen="isMobileScreen" />
    <!-- <BargeReady @Bargeclick="Bargeclick" v-if="upIndex === 1" /> -->
    <el-dialog title="Send email for onboarding" :visible.sync="emailDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'">
      <div>
        <el-form ref="emailForm" :model="emailData" :rules="emailRules" size="small" :label-width="'100px'"
          label-position="left">
          <el-form-item :label="'Email:'" prop="customerEmail">
            <el-input v-model="emailData.customerEmail" clearable size="small" :style="{ width: '100%' }"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="emailDialogVisible = false">{{ $t("btn.close")
          }}</el-button>
          <el-button type="primary" size="mini" @click="handleSendEmail">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="Change quantity" :visible.sync="changeQuantityDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'">
      <div>
        <p class="pb-2">After Submitting, the terminal will approve the change before it is updated in the barging
          nomination</p>
        <el-form ref="changeQuantityForm" :model="changeQuantityData" :rules="changeQuantityRules" size="small"
          label-position="top">
          <el-form-item prop="changeQuantity">
            <template>
              <div><span style="color: red;">*</span>New Quantity</div>
              <el-input ref="qtys" oninput="value=value.replace(/[^\d]/g,'')"
                v-model="changeQuantityData.newNominatedQtyMax" clearable size="small" :style="{ width: '100%' }">
                <div slot="append">MT</div>
              </el-input>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="changeQuantityDialogVisible = false">{{ $t("btn.close")
          }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeQuantity">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="Change Tank(s)" :visible.sync="changeTankDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'">
      <div>
        <p class="pb-2">
          After submitting, your change request will be sent for pending approval.
        </p>
        <el-form ref="changeTankForm" :model="changeTankData" :rules="changeTankRules" size="small"
          label-position="top">
          <el-form-item label="New Tank(s)" prop="newTankIds">
            <el-select v-model="changeTankData.newTankIds" placeholder="Select new tank(s)" clearable multiple
              style="width: 100%;">
              <el-option v-for="item in tankOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="changeTankDialogVisible = false">{{ $t("btn.close")
          }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeTank">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="Change Product" :visible.sync="changeProductDialogVisible"
      :width="isMobileScreen ? '100%' : '500px'">
      <div>
        <p class="pb-2">
          After submitting, your change request will be sent for pending approval.
        </p>
        <el-form ref="changeProductForm" :model="changeProductData" :rules="changeProductRules" size="small"
          label-position="top">
          <el-form-item label="New Product" prop="newProduct">
            <el-select v-model="changeProductData.newProduct" placeholder="Select new product" clearable
              style="width: 100%;">
              <el-option v-for="item in productOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="changeProductDialogVisible = false">{{ $t("btn.close")
          }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeProduct">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="Change Doc" :visible.sync="changeDocDialogVisible" :width="isMobileScreen ? '100%' : '500px'">
      <div>
        <p class="pb-2">After Submitting, the terminal will approve the change before it is updated in the barging
          nomination</p>
        <el-form ref="changeDocForm" :model="changeDocData" :rules="changeDocRules" size="small" label-position="top">
          <el-select size="small" v-model="changeDocData.doc" placeholder="" clearable :style="{ width: '100%' }">
            <el-option v-for="(item, index) in docOptions" :key="index" :label="item.label" :value="item.value"
              :disabled="item.disabled"></el-option>
          </el-select>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button plain type="primary" size="mini" @click="changeDocDialogVisible = false">{{ $t("btn.close")
          }}</el-button>
          <el-button type="primary" size="mini" @click="handleSubmitChangeDoc">{{ $t("btn.submit") }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import checkBargeDialog from "./check-barge-dialog.vue";
import { searchBargeBer, resetBerthReason, getBargeContactNumberList } from '@/services/index';
import { searchBarge, updateNominatedQtyMax, requestProductUpdate, requestTankUpdate, updateCustomCode } from '@/services/user';
import moment from "moment";
import iconOnlyImg from "@/assets/icon-only.png";
import {
  getMvpCompany,
  BargeAdd,
  Amendnomination,
  Booknomination,
  formTankselect,
  JettyAll,
  formall,
  SendEmail,
  submitFreshWaterAvailable,
  updatePriorityStatus,
} from "@/services/user";
import { getSurveyoOptions } from "@/services";
import SuccessDialog from "@/components/common/success-dialog.vue";
import { mapState } from "vuex";
import { VueTelInput } from 'vue-tel-input';
import axios from "axios";
import { checkBerthLoa, getCoLoadNominations, submitChangeDoc, updateCoLoadStatus } from "@/services/form";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  components: { SvgIcon, SuccessDialog, checkBargeDialog, VueTelInput, vSelect },
  props: {
    // 船舶的传值
    createdtable: {
      type: Object,
      default() {
        return {};
      },
    },
    BargeData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 码头的传值
    terminaldatas: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // value1:[],
      // value2:[],
      source: null,
      iconOnlyImg,
      phoneObject: null,
      bargeContactNumbers: [],
      tempJettyNo: '',
      emailData: {
        customerEmail: "",
      },
      formData: {
        customerCompanyName: "",
        noEta: "",
        bargeName: "",
        contact: "",
        balanceInTank: "",
        product: "",
        doc: "",
        block: false,
        blockNomination: "",
        remarks: "",
        nominatedQtyMax: "",
        noEtas: "",
        vesselName: "",
        id: "",
        hideFromTerminal: "0",
        tlist: [],
        slist: [],
        loadingType: null,
        jettyNo: "",
        status: 0,
        customCode: "Own warehouse bunker",
        qtyRequestStatus: false,
        tankRequestStatus: false,
        productRequestStatus: false,
        docRequestStatus: false,
        priorityStatus: null,
      },
      customCodeOptions: [
        { label: "Own warehouse bunker", value: "Own warehouse bunker" },
        { label: "Import", value: "Import" },
        { label: "Export", value: "Export" },
        { label: "3-Point", value: "3-Point" },
      ],
      priorityStatusOptions: [
        { label: 'Prioritised Berthing (Contract)', value: 1 },
        { label: 'No Prioritised Berthing (Contract)', value: 2 },
        { label: 'Prioritised Berthing for this nomination', value: 3 },
        { label: 'No Prioritised Berthing for this nomination', value: 4 },
      ],
      coLoadOptions: [
        { label: 'Co-Loading', value: 1 },
        { label: 'Not Co-Loading', value: 0 },
      ],
      fromdisabled: false,
      userTypes: "",
      emailRules: {
        customerEmail: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
      },
      rules: {
        noEta: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        bargeName: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        balanceInTank: [
          {
            required: true,
            message: "",
            trigger: "blur",
          }
        ],
        nominatedQtyMax: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        tlist: [
          {
            required: true,
            message: "",
            trigger: "blur",
          },
        ],
        jettyNo: [
          {
            required: true,
            trigger: "change",
          },
        ],
        product: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        slist: [],
        doc: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        remarks: [],
        typeOfPilot: [
          {
            required: true,
            trigger: "blur",
          },
        ],
        contactNumber: [
          {
            required: true,
            trigger: "blur",
          },
        ],
      },
      bargeoptions: [],
      productOptions: [
        {
          label: "LSFO",
          value: "LSFO",
        },
        {
          label: "FO380",
          value: "FO380",
        },
        {
          label: "LSMGO",
          value: "LSMGO",
        },
        {
          label: "FO500",
          value: "FO500",
        },
        {
          label: "FO180",
          value: "FO180",
        },
        {
          label: "HSMGO",
          value: "HSMGO",
        },
        {
          label: "B24 VLSFO",
          value: "B24 VLSFO",
        },
        {
          label: "BIO-MGO",
          value: "BIO-MGO",
        },
        {
          label: "B30 VLSFO",
          value: "B30 VLSFO",
        },
      ],
      surveyorOptions: [],
      docOptions: [
        {
          label: "CQ",
          value: "CQ",
        },
        {
          label: "BL",
          value: "BL",
        },
      ],
      operationData: {
        bargeReadiness: null,
        typeOfPilot: "",
        contactNumber: "",
        bargeContactNumber: "",
        bargeContactNumbers: null,
        freshWater: false,
        id: "",
      },
      elinformaData: {
        jettyNo: "",
        berthAssignTiming: "",
        berthAssignTimings: "",
        estimatedBerthTiming: "",
        estimatedBerthTimings: "",
        id: "",
      },
      elinformaDataFromRes: {
        jettyNo: "",
        berthAssignTiming: "",
        berthAssignTimings: "",
        estimatedBerthTiming: "",
        estimatedBerthTimings: "",
        id: "",
      },
      pilotOptions: [
        {
          label: "PSA",
          value: "PSA",
        },
        {
          label: "IHP",
          value: "IHP",
        },
      ],
      jettyNoOptios: [],
      isEdit: true,
      showOperationInput: true,
      showJettyInput: true,
      formVisible: 0,
      academyData: [],
      timeout: null,
      fromdisabled: false,
      OperationFormVisible: true,
      contactdisabled: false,
      userTypes: "",
      elvisible: false,
      Jettyelvisible: true,
      barges: "",
      shipinfos: {},
      // 模糊搜索
      bargeNameloading: false,
      // 提示文字信息
      textvalidate: false,
      // form船舶loading
      isBargeOptionsLoading: true,
      // formloading
      formDataloading: false,
      message: "",
      mvpCompanyData: null,
      tankOptions: [],
      surveyorOptions: [],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      PSAContactNumberIsValid: null,
      emailDialogVisible: false,
      changeQuantityDialogVisible: false,
      changeQuantityData: {
        id: null,
        newNominatedQtyMax: null,
      },
      changeTankDialogVisible: false,
      changeProductDialogVisible: false,
      changeDocDialogVisible: false,
      changeTankData: {
        id: null,
        newTankIds: null,
      },
      changeProductData: {
        id: null,
        newProduct: null,
      },
      changeDocData: {
        id: null,
        doc: null,
      },
      changeDocRules: {
        doc: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
        ],
      },
      changeQuantityRules: {
        newNominatedQtyMax: [
          {
            required: true,
            message: "The field is required",
            trigger: "blur",
          },
        ],
      },
      elFreshWaterData: {
        freshWater: false,
        freshWaterAvailable: null,
        waterVoucher: "",
        waterMeter: "",
        id: "",
      },
      elFreshWaterDataFromRes: {
        freshWater: false,
        freshWaterAvailable: null,
        waterVoucher: "",
        waterMeter: "",
        id: "",
      },
      freshWaterAvailableOptions: [
        { id: 0, value: 0, label: 'Not Selected', },
        { id: 1, value: 1, label: 'Yes', },
        { id: 2, value: 2, label: 'No', },
      ],
      grt: null,
      bargeContactNumberList: [],
      isInitialLoad: true,
      coLoadData: {
        coLoad: 0,
        noEta: '',
        relatedIds: [],
      },
      coLoadDropdownVisible: false,
      coLoadNominationOptions: [],
      selectedCoLoadIds: [],
      selectedCoLoadList: [],
      lastConfirmedCoLoadIds: [],
      myPairedIds: [],
      selectedBargeRequestStatus: null,
      showBargeNotAccepted: false,
      isApplyingCoLoad: false,
      tempSelectedCoLoadIds: [],
      lastConfirmedMainId: null,
      tempSelectedCoLoadKeys: [],
      lastConfirmedCoLoadKeys: [],
      coLoadGroupMap: {},
      coLoadColorMap: {},
    };
  },
  watch: {
    createdtable() {
      this.Setrloe();
      this.GetselectList();
    },
    'formData.tlist': {
      handler() {
        if (this.isInitialLoad) return;
        this.recomputePriorityStatus();
      },
      deep: true,
    },
    disableCustomerSave: {
      immediate: true,
      handler(val) {
        this.$emit("customer-save-disabled", val === true);
      }
    },
  },
  created() {
    if (!this.$route.query.id) {
      this.isInitialLoad = false;
    }
    this.Setrloe();
    this.GetselectList();
    if (this.$route.query.id) {
      this.formDataloading = true;
      this.getdatalist();
    }
  },
  directives: {
    cancelReadOnly(el) {
      const input = el.querySelector('.el-input__inner');
      input.removeAttribute('readonly');
    }
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    isCustomerAdmin() {
      return this.userInfo?.role == 5;
    },
    isCustomer() {
      return this.userInfo?.role == 4;
    },
    bargeImo: function () {
      if (this.formData.bargeName) return this.formData.bargeName;
      return null;
    },
    allowEditPriorityStatus() {
      return this.userRoles == 1 && this.createdtable.status !== 5 && this.createdtable.status !== 4;
    },
    allowToChangeQuantity() {
      return this.userRoles == 5 &&
        (
          this.createdtable.status == 2 ||
          this.createdtable.status == 3 || this.createdtable.status == 4
        )
    },
    allowToChangeDoc() {
      return this.userRoles == 5 &&
        (
          this.createdtable.status == 2 ||
          this.createdtable.status == 3 || this.createdtable.status == 4
        )
    },
    allowEditCustomCode() {
      return this.userRoles == 1 && this.createdtable.status !== 5;
    },
    allowToChangeTank() {
      return this.userRoles == 5 &&
        (
          this.createdtable.status == 2 ||
          this.createdtable.status == 3 || this.createdtable.status == 4
        )
    },
    allowToChangeProduct() {
      return this.userRoles == 5 &&
        (
          this.createdtable.status == 2 ||
          this.createdtable.status == 3 || this.createdtable.status == 4
        )
    },
    allowEditFreshWater() {
      // const isLoadingRole = this.$store.state.userInfo.role === '11';
      // const isCCRRole = this.$store.state.userInfo.role === '2';
      const isBargeRole = this.$store.state.userInfo.role === '8';
      const isJettyAssigned = this.createdtable.status == 2 && this.createdtable.loadingType == null;
      if (isBargeRole && isJettyAssigned) {
        return false
      }
      return true;
    },
    allowEditFreshWaterAvailable() {
      // this.elFreshWaterData.freshWater = true;
      const isLoadingRole = this.$store.state.userInfo.role === '11';
      const isCCRRole = this.$store.state.userInfo.role === '2';
      if ((isLoadingRole || isCCRRole) && this.elFreshWaterData.freshWater == 1) {
        return false;
      }
      return true
    },
    allowEditWaterVoucher() {
      const isLoadingRole = this.$store.state.userInfo.role === '11';
      const isCCRRole = this.$store.state.userInfo.role === '2';
      if ((isLoadingRole || isCCRRole) && this.elFreshWaterData.freshWater == 1 && this.elFreshWaterData.freshWaterAvailable == 1) {
        return false;
      }
      return true
    },
    estimatedBerthTimingDisabled() {
      if (this.$store.state.userInfo.role == 1 && (this.createdtable.status == 1 || this.createdtable.status == 2)) {
        return false
      }
      return true;
    },
    isLogistic() {
      return this.$store.state.userInfo.role === '1'
    },
    coLoadDataVisible() {
      const isCCRRole = this.$store.state.userInfo.role === '2';
      if ((this.isLogistic || isCCRRole) && (this.createdtable.status < 3 && this.createdtable.loadingType == null)) {
        return false
      }
      return true;
    },
    isCustomerCreateOrModify() {
      return this.userInfo?.userType == 2 && this.userInfo?.role == 5; // customer admin
    },
    disableCustomerSave() {
      // if (!this.isCustomerCreateOrModify) return false;
      // const rs = this.selectedBargeRequestStatus;
      // if (!this.formData.bargeName && rs == null) return false;
      // return rs !== "ACCEPTED";
      return false
    },
  },
  methods: {
    updateWaterInput(index) {
      if (index == 1) {
        this.elFreshWaterData.waterVoucher = this.elFreshWaterDataFromRes.waterVoucher;
        this.elFreshWaterData.waterMeter = this.elFreshWaterDataFromRes.waterMeter == "No water meter available" ? "" : this.elFreshWaterDataFromRes.waterMeter;
      } else if (index == 0) {
        this.elFreshWaterData.waterVoucher = ""
        this.elFreshWaterData.waterMeter = ""
      } else if (index == 2) {
        this.elFreshWaterData.waterVoucher = ""
        this.elFreshWaterData.waterMeter = "No water meter available"
      }
    },
    onPSAContactNumberChange(value, phoneObject) {
      this.PSAContactNumberIsValid = phoneObject.valid == true
    },
    onContactNumberChange: function (item, phoneObject) {
      item.phoneNumberIsValid = phoneObject.valid == true
    },
    onContactNumberRemove: function (_index) {
      this.bargeContactNumbers = this.bargeContactNumbers.filter((contact, index) => {
        return index != _index;
      });
    },
    addMoreContactNumber: function () {
      this.bargeContactNumbers.push({
        contactNumber: "",
        phoneNumberIsValid: null
      });
    },
    tankName(id) {
      const match = this.tankOptions.find(t => t.value === id);
      return match ? match.label : id; // Fallback to ID if not found
    },
    noEtaInSeconds: function () {
      if (typeof this.formData.noEtas == "string" && this.formData.noEtas) {
        return moment(this.formData.noEtas, "DD/MM/YYYY hh:mm:ss").unix();
      } else if (typeof this.formData.noEta == "string" && this.formData.noEta) {
        return moment(this.formData.noEta, "DD/MM/YYYY hh:mm:ss").unix();
      } else if (typeof this.formData.noEta == "number" && this.formData.noEta) {
        return this.formData.noEta / 1000;
      } else {
        return null;
      }
    },
    handleImoChange(imo) {
      if (this.source) {
        this.source.cancel();
      }
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();

      let timestamp = this.noEtaInSeconds();

      if (imo == null || timestamp == null || isNaN(timestamp)) return;

      this.mvpCompanyData = null;

      getMvpCompany({ imo, timestamp, cancelToken: this.source.token })
        .then(res => {
          this.mvpCompanyData = res.data;
          this.$message.success("Account found in Marine Vessel Pass: " + this.mvpCompanyData.name);
        }).catch((e) => {
          this.emailDialogVisible = true
        });
    },
    handleSureConfirm() {
      if (this.effectCallback) {
        this.effectCallback();
        this.$refs.checkBargeDialog.close();
      }
    },
    handleUpdateCustomCode() {
      const payload = {
        id: this.formData.id,
        customCode: this.formData.customCode,
      };
      updateCustomCode(payload)
        .then((res) => {
          this.$message.success("Custom Code updated successfully!");
        })
        .catch((err) => {
          this.$message.error("Failed to update Custom Code");
        });
    },

    recomputePriorityStatus() {
      if (this.formData.priorityStatus === 0) this.formData.priorityStatus = null
      const selected = Array.isArray(this.formData.tlist) ? this.formData.tlist : [];

      if (selected.length === 0) {
        this.formData.priorityStatus = null;
        return;
      }

      const tankCodes = selected
        .map(id => {
          const opt = (this.tankOptions || []).find(o => String(o.value) === String(id));
          return opt?.priorityStatus; // 1 / 2 / null
        })
        .filter(v => v === 1 || v === 2);

      if (tankCodes.length === 0) {
        if (String(this.userRoles) === '5') {
          this.formData.priorityStatus = null;
          return;
        }

        if (this.formData.priorityStatus === 3 || this.formData.priorityStatus === 4) return;
        return;
      }
      const derived = tankCodes.includes(1) ? 1 : 2;

      if (String(this.userRoles) === '5') {
        this.formData.priorityStatus = derived;
        return;
      }

      if (this.formData.priorityStatus === 3 || this.formData.priorityStatus === 4) return;

      this.formData.priorityStatus = derived;
    },

    handleUpdatePriorityStatus() {
      if (!this.allowEditPriorityStatus || !this.formData.id) return;

      updatePriorityStatus({
        id: this.formData.id,
        priorityStatus: this.formData.priorityStatus,
      })
        .then(() => this.$message.success("Priority Status updated successfully!"))
        .catch(() => this.$message.error("Failed to update Priority Status"));
    },
    Setrloe() {
      this.userTypes = this.$store.state.userInfo.userType;
      this.userRoles = this.$store.state.userInfo.role;
      // 船舶的值
      if (this.userTypes == 4) {
        this.operationData.id = this.createdtable.id;
        this.fromdisabled = true;
        this.OperationFormVisible = false;
        this.elvisible = this.createdtable.blockNomination >= '2';
      }
      // 码头的值
      if (this.userTypes == 1) {
        if (
          this.$store.state.userInfo.role == 2 &&
          (this.createdtable.status == 1 || this.createdtable.status == 2)
        ) {
          this.Jettyelvisible = false;
        }
        this.elvisible = true;
        this.fromdisabled = true;
      }
      // 客户的值
      if (this.userTypes == 2) {
        this.OperationFormVisible = false;
        this.elvisible = true;
        if (this.$store.state.userInfo.role == 4) {
          this.fromdisabled = true;
        }
      }
      if (this.$route.query.id) {
        this.formDataloading = true;
        this.getdatalist();
      } else {
        this.formData.customerCompanyName = this.$store.state.userInfo.companyName
      }
    },
    // 数据详情列表
    async getdatalist() {
      formall(this.$route.query.id).then(async (res) => {
        this.contactdisabled = res.data.typeOfPilot === 'PSA';
        if (this.$store.state.userInfo.userType == 2 && this.$store.state.userInfo.role == 5 && res.data.blockNomination < '2') {
          this.fromdisabled = false;
        } else {
          this.fromdisabled = true;
        }
        Object.keys(this.formData).forEach((key) => {
          if (res.data[key] !== undefined) {
            this.formData[key] = res.data[key];
          }

        });
        if (this.tankOptions?.length < 1 && res.data.tlistNomination != null && res.data.tlistNomination.length > 0) {
          this.tankOptions = this.formatTankOptions(res.data.tlistNomination);
          if (this.isInitialLoad == false) {
            this.recomputePriorityStatus();
          }
        }

        // Req 225: Show contact by nomination; fallback to selected barge if none.
        const data = { "bargeName": this.formData.bargeName }
        const bargenumberlist = await getBargeContactNumberList(data)
        if (bargenumberlist?.data.contactNumber?.length > 0) {
          this.bargeContactNumbers = bargenumberlist.data.contactNumber.map(c => ({
            contactNumber: c,
            phoneNumberIsValid: true,
          }));
        }
        if (res.data.bargeContactNumber) {
          this.bargeContactNumbers = res.data.bargeContactNumber.split(",").map(c => ({
            contactNumber: c,
            phoneNumberIsValid: true,
          }));
        }

        if (!this.bargeoptions.some(item => item.imo === this.formData.bargeName)) {
          searchBarge(this.formData.bargeName).then(res => {
            if (res.data && res.data.length) {
              this.bargeoptions.push(res.data[0]);
            }
          });

        }

        const currentId = Number(this.formData.id);
        const list = Array.isArray(res.data.coLoadList) ? res.data.coLoadList : [];

        // 1️⃣ Extract mainId
        const mainIdFromApi = list.length ? Number(list[0].mainNomId) : null;
        this.lastConfirmedMainId = mainIdFromApi;

        // 2️⃣ Extract memberIds BUT remove backend self-duplicate
        // (because API includes relatedNomId === mainNomId)
        const memberIds = list
          .map(x => Number(x.relatedNomId))
          .filter(id => id && id !== mainIdFromApi); // ✅ remove self-duplicate

        // 3️⃣ Build full group and dedupe safely
        const groupIds = Array.from(
          new Set([mainIdFromApi, ...memberIds].filter(Boolean))
        );

        // 4️⃣ Paired = everyone except myself
        const pairedIds = groupIds.filter(id => id !== currentId);

        // 5️⃣ Store clean, deduped arrays
        this.myPairedIds = [...pairedIds];
        this.selectedCoLoadIds = [...pairedIds];
        this.lastConfirmedCoLoadIds = [...pairedIds];
        this.tempSelectedCoLoadIds = [...pairedIds];

        // 6️⃣ Set coLoad flag
        this.coLoadData.coLoad = res.data.coLoad || 0;

        if (Number(this.coLoadData.coLoad) === 1) {
          this.tempSelectedCoLoadKeys = [];
          this.lastConfirmedCoLoadKeys = [];

          this.selectedCoLoadList = list
            .filter(x => Number(x.relatedNomId) !== Number(this.formData.id))
            .map(x => ({
              id: x.relatedNomId,
              vesselName: x.vesselName,
              nominatedQtyMax: x.nominatedQtyMax,
              noEta: x.noEta,
            }));

          await this.handleCoLoadChange(1);
        }

        this.bargeoptions.forEach((item) => {
          if (item.imo == this.formData.bargeName) {
            let timestamp = this.noEtaInSeconds();
            if (this.source) {
              this.source.cancel();
            }
            const CancelToken = axios.CancelToken;
            this.source = CancelToken.source();
            getMvpCompany({ imo: item.imo, timestamp, cancelToken: this.source.token })
              .then(res => {
                this.mvpCompanyData = res.data;
              });
            this.shipinfos = item;
          }
        });
        this.formData.noEtas = res.data.noEta;
        this.formData.tlist = res.data?.tlistNomination?.map((tank) => {
          return tank.tid;
        })
        this.formData.slist = res.data?.slistNomination?.map((tank) => {
          return tank.sid;
        })
        if (this.tankOptions?.length < 1 && res.data.tlistNomination != null && res.data.tlistNomination.length > 0) {
          this.tankOptions = this.formatTankOptions(res.data.tlistNomination);
          if (this.isInitialLoad == false) {
            this.recomputePriorityStatus();
          }
        }
        this.grt = res.data.grt
        this.shipinfos.lengthOverall = res.data.lengthOverall
        this.shipinfos.imo = res.data.bargeName
        this.selectedBargeRequestStatus = 'ACCEPTED'
        this.$emit("shipinfos", this.shipinfos);
        if (
          this.$store.state.userInfo.userType == 4 && res.data.blockNomination < '2'
        ) {

          this.elvisible = false;
        } else {
          this.elvisible = true;
        }
        Object.keys(this.operationData).forEach((key) => {
          if (res.data[key]) {
            this.operationData[key] = res.data[key];
          }
        });
        // 控制船舶填写权限
        if (
          (res.data.status == 1 || res.data.status == 2) &&
          this.$store.state.userInfo.userType == 1 &&
          this.$store.state.userInfo.role == 2
        ) {
          this.modifyJettyInformationPermission();
        } else {
          this.Jettyelvisible = true;
        }
        Object.keys(this.elinformaData).forEach((key) => {
          this.elinformaData[key] = res.data[key];
          this.elinformaData.berthAssignTimings = res.data.berthAssignTiming;
          this.elinformaData.estimatedBerthTimings = res.data.estimatedBerthTiming;
        });
        Object.keys(this.elinformaDataFromRes).forEach((key) => {
          this.elinformaDataFromRes[key] = this.elinformaData[key];
        });
        Object.keys(this.elFreshWaterData).forEach((key) => {
          if (res.data[key]) {
            this.elFreshWaterData[key] = res.data[key];
          }
        });
        Object.keys(this.elFreshWaterDataFromRes).forEach((key) => {
          this.elFreshWaterDataFromRes[key] = this.elFreshWaterData[key];
        });
        this.tempJettyNo = this.elinformaData.jettyNo
        this.formDataloading = false;
        this.modifyBargeInformationPermission();
        if (this.userTypes === "2") {
          if (
            (this.formData.status === 0 || this.formData.status === 1)
            && !this.formData.jettyNo
          ) {
            this.fromdisabled = false;
          } else {
            this.fromdisabled = true;
          }
        }

        this.formDataloading = false;
        this.formData.qtyRequestStatus = res.data.qtyRequestStatus ?? false;
        this.formData.tankRequestStatus = res.data.tankRequestStatus ?? false;
        this.formData.productRequestStatus = res.data.productRequestStatus ?? false;
        this.formData.newTank = res.data.newTank ?? null;
        this.formData.newProduct = res.data.newProduct ?? null;
        this.formData.newNominatedQtyMax = res.data.newNominatedQtyMax ?? null;
        this.formData.docRequestStatus = res.data.docRequestStatus ?? false;
        this.formData.newDoc = res.data.newDoc ?? null;
        this.formData.priorityStatus = Number(res.data.priorityStatus);
      });


      this.$nextTick(() => { this.isInitialLoad = false; });

      if (this.createdtable.typeOfPilot == "IHP") {
        this.textvalidate = true;
      } else {
        this.textvalidate = false;
      }
    },
    // 下拉列表
    GetselectList() {
      // Tank列表
      formTankselect().then((res) => {
        if (res.code == 200 && res.data !== null && res.data?.length > 0) {
          this.tankOptions = this.formatTankOptions(res.data);
          this.recomputePriorityStatus();
        }
      });
      // formSurveyorselect(7, 3).then((res) => {
      //   if (res.code == 200) {
      //     this.surveyorOptions = res.data;
      //   }
      // });
      // 码头Jetty下拉
      JettyAll().then((res) => {
        if (res.code == 200) {
          this.jettyNoOptios = res.rows;
        }
      });
      // Barge下拉
      // getSelectVessel().then((res) => {
      //   if (res.code == 200) {
      //     this.bargeoptions = res.data;
      //     this.bargelogdaing = false;
      //   }
      // });
      getSurveyoOptions().then((res) => {
        if (res.code == 200 && res.data !== null && res.data.length > 0) {
          this.surveyorOptions = res.data.map((item) => {
            return {
              label: item.nickName,
              value: item.userId
            }
          });
        }

      });
    },
    async handleBerthAssignment(data, callback) {
      const unassignBerth = async () => {
        let res = await Amendnomination(data);
        if (res.code == 200) {
          callback()
          this.tempJettyNo = this.elinformaData.jettyNo
        }
      }
      if (!this.Jettyelvisible && this.elinformaData.jettyNo != null && this.elinformaData.jettyNo.trim() == '' && this.tempJettyNo.trim() != '') {
        try {
          await this.$prompt('Reason', 'Unassign Berth', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputType: 'textarea',
            inputPattern: /^(?!\s*$).+/,
            inputErrorMessage: 'Reason is required',
            closeOnClickModal: false,
          })
            .then(({ value }) => {
              resetBerthReason({ bid: this.formData.id, remark: value }).then(() => {
                unassignBerth()
              });
            })
            .catch(() => { });
        } catch (error) {
          this.$emit("loading", "3")
        }
      } else {
        unassignBerth()
      }
    },
    async handleBook(callback) {
      let res = await Booknomination(this.$route.query.id)
      if (res.code == 200) {
        //  this.$refs.successDialog.open();
        //  this.$emit("loading", "1");
        //  this.$refs.successDialog.message = "Booked successfully!";
        callback();
      }
    },
    submitForm(callback) {
      // 控制 Tank 和 Qty 只能输入数字
      this.userTypes = this.$store.state.userInfo.userType;
      const QtyNumber = this.$refs.qtys;
      this.formData.nominatedQtyMax = QtyNumber.value;
      const TankNumber = this.$refs.Tanks;
      this.formData.balanceInTank = TankNumber.value;
      // todo
      if (this.userTypes == "4") {
        this.operationData.freshWater = this.elFreshWaterData.freshWater
        this.$refs["elOperationForm"].validate((valid) => {
          if (this.PSAContactNumberIsValid == false) {
            return this.$message.error("Invalid PSA Contact Number");
          }

          if (this.bargeContactNumbers.length > 0) {
            var phoneNumberIsValid = false;
            var result = [];
            this.bargeContactNumbers.forEach((el) => {
              result.push(el.contactNumber);
              phoneNumberIsValid = el.phoneNumberIsValid;
            })
            if (!phoneNumberIsValid) return alert('Please check the provided contact numbers');
            this.operationData.bargeContactNumber = result.join(",");
            this.operationData.bargeContactNumbers = this.bargeContactNumbers;
          }

          if (this.bargeContactNumbers.length == 0) {
            this.operationData.bargeContactNumber = "";
            this.operationData.bargeContactNumbers = null;
          }

          if (this.operationData.contactNumber) {
            this.operationData.contactNumber = this.operationData.contactNumber;
          }

          if (!valid) return;
          callback();

          let dateFormatted = moment(this.operationData.bargeReadiness, "DD/MM/YYYY hh:mm:ss").format()
          let bargeReadinessValue = new Date(dateFormatted).valueOf()

          Amendnomination({
            ...this.operationData,
            lengthOverall: sessionStorage.getItem('lengthOverall'),
            bargeReadiness: bargeReadinessValue > 0 ? bargeReadinessValue : null
          })
            .then((res) => {
              if (res.code == 200) {
                this.$refs.successDialog.show = true;
                this.$refs.successDialog.message =
                  "Information submitted successfully!";
                this.resetForm();
                this.$emit("loading", "1");
              }
            })
            .catch(() => {
              this.$emit("loading", "3");
            });
        });
      }
      if (this.userTypes == "2") {
        if (this.$route.query.id) {
          this.formData.id = this.$route.query.id;
          this.operationData.id = this.$route.query.id;
          this.elinformaData.id = this.$route.query.id;
          this.$refs["elForm"].validate((valid) => {
            if (!valid) return;
            callback();
            Amendnomination({
              ...this.formData,
              lengthOverall: sessionStorage.getItem('lengthOverall'),
              grt: this.grt
            })
              .then((res) => {
                if (res.code == 200) {
                  this.$refs.successDialog.open();
                  this.$refs.successDialog.message =
                    "Changes saved successfully!";
                  this.$emit("loading", "1");
                }
              })
              .catch(() => {
                this.$emit("loading", "3");
              });
          });
        } else {
          this.$refs["elForm"].validate((valid) => {
            if (!valid) return;
            callback();
            BargeAdd({
              ...this.formData,
              lengthOverall: sessionStorage.getItem('lengthOverall'),
              grt: this.grt
            })
              .then((res) => {
                if (res.code == 200) {
                  this.$refs.successDialog.open();
                  this.$refs.successDialog.message =
                    "Barging Nomination created successfully!";
                  this.$refs.successDialog.userAdd = 1;
                  this.$emit("loading", "1");
                }
              })
              .catch((error) => {
                if (error.toString() == 'Error: Selected ship not active in Marine Vessel Pass (MVP). Please contact admin for onboarding.') {
                  this.emailDialogVisible = true
                }
                this.$emit("loading", "3");
              });
          });
        }
      }
      if (this.userTypes == "1") {
        const freshWaterChange = JSON.stringify(this.elFreshWaterData) !== JSON.stringify(this.elFreshWaterDataFromRes)
        const jettyInfoChange = JSON.stringify(this.elinformaData) !== JSON.stringify(this.elinformaDataFromRes)
        if (this.userInfo.role == "11" && freshWaterChange) {
          this.handleSubmitFreshWaterAvailable()
          callback();
          return
        }
        if (this.userInfo.role == "2" && !jettyInfoChange && freshWaterChange) {
          this.handleSubmitFreshWaterAvailable()
          callback();
          return
        }
        if (this.userInfo.role == "2" && freshWaterChange) {
          this.handleSubmitFreshWaterAvailable()
        }
        this.$refs["elinformaForm"].validate((valid) => {
          this.$parent.$refs["shipTabView"].$refs["shipInfoForm"].validate((shipFormValid) => {
            if (!shipFormValid) return this.$message.error("Please fill in the overall length of the barge.");
            if (!valid) return;
            let submit = () => {
              this.elinformaData.berthAssignTiming = this.elinformaData.berthAssignTimings
              const berthAssignmentCallback = () => {
                this.$refs.successDialog.open();
                this.$emit("loading", "1");
                this.$refs.successDialog.message =
                  "Information submitted successfully!";
                // this.resetForm();
              }
              this.handleBerthAssignment(
                { ...this.elinformaData, lengthOverall: sessionStorage.getItem('lengthOverall') },
                berthAssignmentCallback
              )
            }
            if (this.elinformaData.berthAssignTimings && this.elinformaData.jettyNo) {
              searchBargeBer({
                berthName: this.elinformaData.jettyNo,
                lengthOverall: sessionStorage.getItem('lengthOverall')
              }).then(result => {
                if (result.code == 200) {
                  submit();
                } else {
                  this.message = result.msg;
                  this.effectCallback = submit;
                  this.$refs.checkBargeDialog.open();
                }
              })
            } else {
              submit();
            }
          })

        });
      }
    },
    resetForm() {
      // this.$refs["elForm"].resetFields();
      // this.$refs["elOperationForm"].resetFields();
      // this.$refs["elinformaForm"].resetFields();
    },
    handleSendEmail() {
      this.$refs["emailForm"].validate((valid) => {
        if (valid) {
          SendEmail(this.emailData).then(res => {
            this.emailDialogVisible = false
          })
        }
      })
    },
    async imochange() {
      this.operationData = {};
      this.textvalidate = false;
      this.handleImoChange(this.bargeImo);

      const selected = (this.bargeoptions || []).find(x => x.imo == this.bargeImo);

      this.selectedBargeRequestStatus = selected ? selected.requestStatus : null;
      // this.showBargeNotAccepted = this.selectedBargeRequestStatus == null && this.selectedBargeRequestStatus !== "ACCEPTED";
      this.showBargeNotAccepted = false;

      // if (this.selectedBargeRequestStatus !== "ACCEPTED") {
      //   this.$message.warning("The barge selected has not been accepted yet.");
      // } else if (selected) {
      this.shipinfos = selected;
      this.formData.vesselName = selected.bargeName;
      this.grt = selected.grossTonnageGt;
      // }
      const data = { "bargeName": this.bargeImo }
      const res = await getBargeContactNumberList(data)
      this.bargeContactNumbers = res.data.contactNumber.map(c => ({
        contactNumber: c,
        phoneNumberIsValid: true,
      }));
      this.$emit("shipinfos", this.shipinfos);
    },
    // 表单时间函数
    Timehangder(val) {
      if (!val) {
        this.elinformaData.berthAssignTiming = null;
        this.elinformaData.berthAssignTimings = null;
        return;
      }
      let a = val.split("/");
      let b = a[2].slice(0, 4);
      let d = a[2].slice(4);
      let c = b + "/" + a[1] + "/" + a[0] + d;
      if (this.userTypes == 2) {
        this.formData.noEta = new Date(c).valueOf();
        this.formData.noEtas = val;
        this.handleImoChange(this.bargeImo);
      }
      if (this.userTypes == 4) {
        this.operationData.bargeReadiness = new Date(c);
      }
      if (this.userTypes == 1) {
        this.elinformaData.berthAssignTiming = new Date(c).valueOf();
        this.elinformaData.berthAssignTimings = val;
      }
    },
    onEstimatedBerthTimingChange(val) {
      if (!val) {
        this.elinformaData.estimatedBerthTiming = null;
        this.elinformaData.estimatedBerthTimings = null;
        return;
      }
      if (this.userTypes == 1) {
        let a = val.split("/");
        let b = a[2].slice(0, 4);
        let d = a[2].slice(4);
        let c = b + "/" + a[1] + "/" + a[0] + d;
        this.elinformaData.estimatedBerthTiming = new Date(c).valueOf();
        this.elinformaData.estimatedBerthTimings = val;
      }
    },

    // 船舶表单控制
    typeOfPilotChange(val) {
      val == "PSA" ? (this.contactdisabled = true) : (this.contactdisabled = false);
      val == "IHP" ? (this.textvalidate = true) : (this.textvalidate = false);
      if (val == "IHP") {
        this.operationData.contactNumber = ""
        this.PSAContactNumberIsValid = true
      }
    },
    upup() {
      if (this.userTypes == 4) {
        this.$emit("upup", "4");
      }
      if (this.userTypes == 2) {
        this.$emit("upup", "2");
      }
      if (this.userTypes == 1) {
        this.$emit("upup", "1");
      }
    },
    async handleSearchBarge(query) {
      if (query !== '') {
        this.isBargeOptionsLoading = true;
        try {
          const res = await searchBarge(query);
          this.bargeoptions = res.data;
        } catch (error) {
          this.bargeoptions = [];
        } finally {
          this.isBargeOptionsLoading = false;
        }
      } else {
        this.bargeoptions = [];
      }
    },
    allowChangeBarge() {
      // customer is not allow to modify barge after barge ready
      return this.userTypes == 2 && this.$store.state.userInfo.role == 5 && this.createdtable.status > 0;
    },
    modifyBargeInformationPermission() {
      // if block nomination is booked, all barge's  information can not modify
      if (this.formData.blockNomination >= "2") {
        this.fromdisabled = true
      }
    },
    modifyJettyInformationPermission() {
      this.Jettyelvisible = true
      if (this.formData.status <= 3) {
        if (this.formData.blockNomination < "2") {
          this.Jettyelvisible = false
        } else if (this.formData.blockNomination == "2" && (this.formData.loadingType == null || this.formData.loadingType < 4)) {
          this.Jettyelvisible = false
        }
      }
    },
    disabledDate(date) {
      const currentDate = new Date();
      return date < currentDate.setDate(currentDate.getDate() - 1);
    },
    async handleSubmitChangeQuantity() {
      this.$refs["changeQuantityForm"].validate(async (valid) => {
        if (valid) {
          this.changeQuantityData.id = this.createdtable.id
          await updateNominatedQtyMax(this.changeQuantityData).then(res => {
            this.formData.qtyRequestStatus = true;
            this.formData.newNominatedQtyMax = this.changeQuantityData.newNominatedQtyMax;
            this.changeQuantityDialogVisible = false
          })
        }
      })
    },
    async handleSubmitChangeTank() {
      this.$refs["changeTankForm"].validate(async (valid) => {
        if (valid) {
          const payload = {
            nominationId: this.createdtable.id,
            tankIds: this.changeTankData.newTankIds
          };
          await requestTankUpdate(payload)
            .then(() => {
              this.formData.tankRequestStatus = true;
              this.formData.newTank = this.changeTankData.newTankIds
                .map(id => this.tankName(id))
                .join(', '); // Add this
              this.changeTankDialogVisible = false;
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    async handleSubmitChangeProduct() {
      this.$refs["changeProductForm"].validate(async (valid) => {
        if (valid) {
          const payload = {
            id: this.createdtable.id,
            product: this.changeProductData.newProduct
          };
          await requestProductUpdate(payload)
            .then(() => {
              this.formData.productRequestStatus = true;
              this.formData.newProduct = this.changeProductData.newProduct; // Add this
              this.changeProductDialogVisible = false;
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    async handleSubmitFreshWaterAvailable() {
      const data = {
        ...this.elFreshWaterData
      }
      delete data.freshWater;
      await submitFreshWaterAvailable(data).then(res => {
        if (res.code == 200) {
          this.$message.success('Save Fresh Water Detail Success');
        }
      })
    },
    openChangeQuantityDialog() {
      this.changeQuantityData.newNominatedQtyMax = this.formData.newNominatedQtyMax ?? this.formData.nominatedQtyMax;
      this.changeQuantityData.id = this.createdtable.id;
      this.$nextTick(() => {
        this.$refs.changeQuantityForm?.clearValidate();
        this.changeQuantityDialogVisible = true;
      });
    },
    openChangeTankDialog() {
      if ((!this.changeTankData.newTankIds || this.changeTankData.newTankIds.length === 0) && this.formData.newTank) {
        this.changeTankData.newTankIds = this.formData.newTank
          .split(',')
          .map(t => t.trim())
          .map(tank => {
            const match = this.tankOptions.find(opt => opt.label === tank);
            return match ? match.value : tank;
          });
      }

      this.$nextTick(() => {
        this.$refs.changeTankForm?.clearValidate();
        this.changeTankDialogVisible = true;
      });
    },
    openChangeProductDialog() {
      if (!this.changeProductData.newProduct && this.formData.newProduct) {
        // Convert label back to value, if needed (assuming label = value)
        const match = this.productOptions.find(opt => opt.label === this.formData.newProduct);
        this.changeProductData.newProduct = match ? match.value : this.formData.newProduct;
      }

      this.$nextTick(() => {
        this.$refs.changeProductForm?.clearValidate();
        this.changeProductDialogVisible = true;
      });
    },

    openChangeDocDialog() {
      this.changeDocData.doc = this.formData.newDoc ?? this.formData.doc;
      this.changeDocData.id = this.createdtable.id;
      this.$nextTick(() => {
        this.$refs.changeDocForm?.clearValidate();
        this.changeDocDialogVisible = true;
      });
    },

    // 模糊查询
    // remoteMethod(query) {
    //   if (query !== "") {
    //     this.bargeNameloading = true;
    //     setTimeout(() => {
    //       this.bargeNameloading = false;
    //       this.bargeoptions = this.bargeoptions.filter((item) => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 200);
    //   } else {
    //     this.options = [];
    //   }
    // },
    // helper to format tank options with rental dates and disabled flag

    formatTankOptions(items) {
      const now = moment();
      const companyId = String(this.userInfo?.companyId ?? '');

      const userCompanyName = String(this.userInfo?.companyName ?? '').trim().toLowerCase();

      const matchByIdentity = (entry) => {
        if (!entry) return false;

        // 1) preferred match
        if (entry.cid !== null && entry.cid !== undefined && String(entry.cid) === companyId) return true;

        // 2) fallback: cid is null in your response, so match by companyName
        if (userCompanyName && entry.companyName && String(entry.companyName).trim().toLowerCase() === userCompanyName) {
          return true;
        }

        return false;
      };

      const parseEntryRange = (entry) => {
        if (!entry) return { from: null, to: null };
        const from = entry.rentalDateFrom ? moment(entry.rentalDateFrom, 'YYYY-MM-DD HH:mm:ss') : null;
        let to = entry.rentalDateTo ? moment(entry.rentalDateTo, 'YYYY-MM-DD HH:mm:ss') : null;
        const grace = (entry.gracePeriodDays !== undefined && entry.gracePeriodDays !== null)
          ? Number(entry.gracePeriodDays) || 0
          : 0;
        if (to && grace > 0) to = to.clone().add(grace, 'days');
        return { from, to };
      };

      return (items || []).map(item => {

        // --- FILTER LOGIC STARTS ---
        const clist = Array.isArray(item.clistCompany)
          ? item.clistCompany
          : (Array.isArray(item.cListCompany) ? item.cListCompany : []);

        // no company restrictions -> enabled
        if (clist.length === 0) {
          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix: '',
            value: item.tid ?? item.id ?? item.value,
            disabled: false,
            priorityStatus: null,
          };
        }

        let matchEntry = null;
        let parentEntry = null;
        let matchedIsChild = false;

        // 1) try matching childCompany under each top-level
        for (const top of clist) {
          if (Array.isArray(top.childCompanies) && top.childCompanies.length > 0) {
            const ch = top.childCompanies.find(ch => String(ch.cid) === companyId);
            if (ch) {
              matchEntry = ch;
              parentEntry = top;
              matchedIsChild = true;
              break;
            }
          }
        }

        // 2) try top-level match
        if (!matchEntry) {
          const top = clist.find(c => String(c.cid) === companyId) || null;
          if (top) {
            matchEntry = top;
            parentEntry = null;
            matchedIsChild = false;
          }
        }

        // 3) fallback to component-level lists
        if (!matchEntry && Array.isArray(this.cListCompany) && this.cListCompany.length) {
          for (const top of this.cListCompany) {
            if (Array.isArray(top.childCompanies) && top.childCompanies.length > 0) {
              const ch = top.childCompanies.find(ch => String(ch.cid) === companyId);
              if (ch) {
                matchEntry = ch;
                parentEntry = top;
                matchedIsChild = true;
                break;
              }
            }
          }
          if (!matchEntry) {
            const top = this.cListCompany.find(c => String(c.cid) === companyId) || null;
            if (top) {
              matchEntry = top;
              parentEntry = null;
              matchedIsChild = false;
            }
          }
        }
        if (!matchEntry && Array.isArray(this.childCompanies) && this.childCompanies.length) {
          matchEntry = this.childCompanies.find(c => String(c.cid) === companyId) || null;
          if (matchEntry) matchedIsChild = true;
        }

        // no match => disabled
        if (!matchEntry) {
          const tankPriorityStatus =
            (matchEntry && matchEntry.priorityStatus) ||
            (parentEntry && parentEntry.priorityStatus) ||
            null;
          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix: '',
            value: item.tid ?? item.id ?? item.value,
            disabled: true,
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        // ✅ CHILD MATCH
        if (matchedIsChild) {
          const { from, to } = parseEntryRange(matchEntry);
          const inRange = from && to && now.isBetween(from, to, undefined, '[]');
          const dateSuffix = (from && to)
            ? `${from.format('YYYY-MM-DD HH:mm:ss')} - ${to.format('YYYY-MM-DD HH:mm:ss')}` : '';
          const tankPriorityStatus =
            (matchEntry && matchEntry.priorityStatus) ||
            (parentEntry && parentEntry.priorityStatus) ||
            null;

          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix,
            value: item.tid ?? item.id ?? item.value,
            disabled: !(from && to && inRange),
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        const topEntry = matchEntry;
        const topHasChildren = Array.isArray(topEntry.childCompanies) && topEntry.childCompanies.length > 0;
        const topRange = parseEntryRange(topEntry);
        const topFrom = topRange.from;
        const topTo = topRange.to;
        const tankPriorityStatus =
          (matchEntry && matchEntry.priorityStatus) ||
          (parentEntry && parentEntry.priorityStatus) ||
          null;

        if (!topEntry.rentalDateFrom && !topEntry.rentalDateTo) {
          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix: '',
            value: item.tid ?? item.id ?? item.value,
            disabled: false,
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        if (!topHasChildren) {
          if (!topFrom && !topTo) {
            return {
              label: `${item.tankName || item.tankNumber || ''}`,
              dateSuffix: '',
              value: item.tid ?? item.id ?? item.value,
              disabled: false,
              priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
            };
          }
          const topInRangeWhenNoChildren = topFrom && topTo && now.isBetween(topFrom, topTo, undefined, '[]');
          const dateSuffix = (topFrom && topTo)
            ? `${topFrom.format('YYYY-MM-DD HH:mm:ss')} - ${topTo.format('YYYY-MM-DD HH:mm:ss')}` : '';

          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix,
            value: item.tid ?? item.id ?? item.value,
            disabled: !(topFrom && topTo && topInRangeWhenNoChildren),
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        let anyChildActiveNow = false;
        for (const ch of topEntry.childCompanies || []) {
          const { from: chFrom, to: chTo } = parseEntryRange(ch);
          if (chFrom && chTo && now.isBetween(chFrom, chTo, undefined, '[]')) {
            anyChildActiveNow = true;
            break;
          }
        }

        if (anyChildActiveNow) {
          const dateSuffix = (topFrom && topTo)
            ? `${topFrom.format('YYYY-MM-DD HH:mm:ss')} - ${topTo.format('YYYY-MM-DD HH:mm:ss')}` : '';

          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix,
            value: item.tid ?? item.id ?? item.value,
            disabled: true,
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        const topInRange = topFrom && topTo && now.isBetween(topFrom, topTo, undefined, '[]');
        const topDateSuffix = (topFrom && topTo)
          ? `${topFrom.format('YYYY-MM-DD HH:mm:ss')} - ${topTo.format('YYYY-MM-DD HH:mm:ss')}` : '';

        return {
          label: `${item.tankName || item.tankNumber || ''}`,
          dateSuffix: topDateSuffix,
          value: item.tid ?? item.id ?? item.value,
          disabled: !(topFrom && topTo && topInRange),
          priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
        };
      });
    },

    normalizePriorityStatusCode(raw) {
      if (raw === 1 || raw === 2) return raw;
      if (raw === '1' || raw === '2') return Number(raw);

      const compact = String(raw ?? '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '');

      if (compact === 'prioritisedberthing' || compact === 'prioritizedberthing') return 1;
      if (
        compact === 'noprioritisedberthing' ||
        compact === 'noprioritizedberthing' ||
        compact === 'nopriorityberthing'
      ) return 2;

      return null;
    },
    // helper to format tank options with rental dates and disabled flag

    formatTankOptions(items) {
      const now = moment();
      const companyId = String(this.userInfo?.companyId ?? '');

      const userCompanyName = String(this.userInfo?.companyName ?? '').trim().toLowerCase();

      const matchByIdentity = (entry) => {
        if (!entry) return false;

        // 1) preferred match
        if (entry.cid !== null && entry.cid !== undefined && String(entry.cid) === companyId) return true;

        // 2) fallback: cid is null in your response, so match by companyName
        if (userCompanyName && entry.companyName && String(entry.companyName).trim().toLowerCase() === userCompanyName) {
          return true;
        }

        return false;
      };

      const parseEntryRange = (entry) => {
        if (!entry) return { from: null, to: null };
        const from = entry.rentalDateFrom ? moment(entry.rentalDateFrom, 'YYYY-MM-DD HH:mm:ss') : null;
        let to = entry.rentalDateTo ? moment(entry.rentalDateTo, 'YYYY-MM-DD HH:mm:ss') : null;
        const grace = (entry.gracePeriodDays !== undefined && entry.gracePeriodDays !== null)
          ? Number(entry.gracePeriodDays) || 0
          : 0;
        if (to && grace > 0) to = to.clone().add(grace, 'days');
        return { from, to };
      };

      return (items || []).map(item => {

        // --- FILTER LOGIC STARTS ---
        const clist = Array.isArray(item.clistCompany)
          ? item.clistCompany
          : (Array.isArray(item.cListCompany) ? item.cListCompany : []);

        // no company restrictions -> enabled
        if (clist.length === 0) {
          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix: '',
            value: item.tid ?? item.id ?? item.value,
            disabled: false,
            priorityStatus: null,
          };
        }

        let matchEntry = null;
        let parentEntry = null;
        let matchedIsChild = false;

        // 1) try matching childCompany under each top-level
        for (const top of clist) {
          if (Array.isArray(top.childCompanies) && top.childCompanies.length > 0) {
            const ch = top.childCompanies.find(ch => String(ch.cid) === companyId);
            if (ch) {
              matchEntry = ch;
              parentEntry = top;
              matchedIsChild = true;
              break;
            }
          }
        }

        // 2) try top-level match
        if (!matchEntry) {
          const top = clist.find(c => String(c.cid) === companyId) || null;
          if (top) {
            matchEntry = top;
            parentEntry = null;
            matchedIsChild = false;
          }
        }

        // 3) fallback to component-level lists
        if (!matchEntry && Array.isArray(this.cListCompany) && this.cListCompany.length) {
          for (const top of this.cListCompany) {
            if (Array.isArray(top.childCompanies) && top.childCompanies.length > 0) {
              const ch = top.childCompanies.find(ch => String(ch.cid) === companyId);
              if (ch) {
                matchEntry = ch;
                parentEntry = top;
                matchedIsChild = true;
                break;
              }
            }
          }
          if (!matchEntry) {
            const top = this.cListCompany.find(c => String(c.cid) === companyId) || null;
            if (top) {
              matchEntry = top;
              parentEntry = null;
              matchedIsChild = false;
            }
          }
        }
        if (!matchEntry && Array.isArray(this.childCompanies) && this.childCompanies.length) {
          matchEntry = this.childCompanies.find(c => String(c.cid) === companyId) || null;
          if (matchEntry) matchedIsChild = true;
        }

        // no match => disabled
        if (!matchEntry) {
          const tankPriorityStatus =
            (matchEntry && matchEntry.priorityStatus) ||
            (parentEntry && parentEntry.priorityStatus) ||
            null;
          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix: '',
            value: item.tid ?? item.id ?? item.value,
            disabled: true,
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        // ✅ CHILD MATCH
        if (matchedIsChild) {
          const { from, to } = parseEntryRange(matchEntry);
          const inRange = from && to && now.isBetween(from, to, undefined, '[]');
          const dateSuffix = (from && to)
            ? `${from.format('YYYY-MM-DD HH:mm:ss')} - ${to.format('YYYY-MM-DD HH:mm:ss')}` : '';
          const tankPriorityStatus =
            (matchEntry && matchEntry.priorityStatus) ||
            (parentEntry && parentEntry.priorityStatus) ||
            null;

          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix,
            value: item.tid ?? item.id ?? item.value,
            disabled: !(from && to && inRange),
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        // ✅ TOP-LEVEL MATCH
        const topEntry = matchEntry;
        const topHasChildren = Array.isArray(topEntry.childCompanies) && topEntry.childCompanies.length > 0;
        const topRange = parseEntryRange(topEntry);
        const topFrom = topRange.from;
        const topTo = topRange.to;
        const tankPriorityStatus =
          (matchEntry && matchEntry.priorityStatus) ||
          (parentEntry && parentEntry.priorityStatus) ||
          null;

        // Rule 1: top match, no rental dates → enable
        if (!topEntry.rentalDateFrom && !topEntry.rentalDateTo) {
          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix: '',
            value: item.tid ?? item.id ?? item.value,
            disabled: false,
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        // Rule 2: top match, no children → check top dates
        if (!topHasChildren) {
          if (!topFrom && !topTo) {
            return {
              label: `${item.tankName || item.tankNumber || ''}`,
              dateSuffix: '',
              value: item.tid ?? item.id ?? item.value,
              disabled: false,
              priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
            };
          }
          const topInRangeWhenNoChildren = topFrom && topTo && now.isBetween(topFrom, topTo, undefined, '[]');
          const dateSuffix = (topFrom && topTo)
            ? `${topFrom.format('YYYY-MM-DD HH:mm:ss')} - ${topTo.format('YYYY-MM-DD HH:mm:ss')}` : '';

          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix,
            value: item.tid ?? item.id ?? item.value,
            disabled: !(topFrom && topTo && topInRangeWhenNoChildren),
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        // Rule 3 & 4: top has children
        let anyChildActiveNow = false;
        for (const ch of topEntry.childCompanies || []) {
          const { from: chFrom, to: chTo } = parseEntryRange(ch);
          if (chFrom && chTo && now.isBetween(chFrom, chTo, undefined, '[]')) {
            anyChildActiveNow = true;
            break;
          }
        }

        if (anyChildActiveNow) {
          const dateSuffix = (topFrom && topTo)
            ? `${topFrom.format('YYYY-MM-DD HH:mm:ss')} - ${topTo.format('YYYY-MM-DD HH:mm:ss')}` : '';

          return {
            label: `${item.tankName || item.tankNumber || ''}`,
            dateSuffix,
            value: item.tid ?? item.id ?? item.value,
            disabled: true,
            priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
          };
        }

        // Final: no active child → check top range
        const topInRange = topFrom && topTo && now.isBetween(topFrom, topTo, undefined, '[]');
        const topDateSuffix = (topFrom && topTo)
          ? `${topFrom.format('YYYY-MM-DD HH:mm:ss')} - ${topTo.format('YYYY-MM-DD HH:mm:ss')}` : '';

        return {
          label: `${item.tankName || item.tankNumber || ''}`,
          dateSuffix: topDateSuffix,
          value: item.tid ?? item.id ?? item.value,
          disabled: !(topFrom && topTo && topInRange),
          priorityStatus: this.normalizePriorityStatusCode(tankPriorityStatus),
        };
      });
    },

    normalizePriorityStatusCode(raw) {
      if (raw === 1 || raw === 2) return raw;
      if (raw === '1' || raw === '2') return Number(raw);

      const compact = String(raw ?? '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/-/g, '');

      if (compact === 'prioritisedberthing' || compact === 'prioritizedberthing') return 1;
      if (
        compact === 'noprioritisedberthing' ||
        compact === 'noprioritizedberthing' ||
        compact === 'nopriorityberthing'
      ) return 2;

      return null;
    },
    onJettyNoChange(val) {
      checkBerthLoa({
        jettyNo: val,
        loa: sessionStorage.getItem('lengthOverall')
      }).then(res => {
        if (res.code != 200) {
          this.$message.error(res.msg);
          this.elinformaData.jettyNo = null;
        }
        else {
          this.elinformaData.jettyNo = val;

        }
      })
    },
    handleSubmitChangeDoc() {
      this.$refs["changeDocForm"].validate(async (valid) => {
        if (valid) {
          this.changeDocData.id = this.createdtable.id
          await submitChangeDoc(this.changeDocData).then(res => {
            this.getdatalist();
            this.changeDocDialogVisible = false
          })
        }
      })
    },
    async handleCoLoadChange(value) {
      this.coLoadData.coLoad = value;
      const currentId = Number(this.formData.id);
      const pairedIds = Array.isArray(this.myPairedIds) ? this.myPairedIds.map(Number) : [];

      if (value == 0) {
        try {
          await this.$confirm(
            `This nomination (${currentId}) is currently co-loading with ${pairedIds.join(', ')}.\n\nDo you want to unco-load? Do note that the nomination eta will change to ${this.formData.noEtas || this.formData.noEta} after unco-loading.`,
            'Confirm Unco-Load',
            {
              confirmButtonText: 'Unco-Load',
              cancelButtonText: 'Cancel',
              type: 'warning',
              closeOnClickModal: false,
            }
          );
        } catch (e) {
          this.coLoadData.coLoad = 1;
          return;
        }
        try {
          const mainId = this.getPreviousCoLoadMainId();
          const relatedIds = this.getPreviousCoLoadRelatedIds();

          this.coLoadData.mainId = mainId;
          this.coLoadData.relatedIds = relatedIds;
          this.coLoadData.noEta = null;

          const res = await updateCoLoadStatus({ ...this.coLoadData, coLoad: 0 });
          if (res.code === 200) {
            this.$message.success('Co-Load nomination cleared successfully');
            this.lastConfirmedCoLoadIds = [];
            this.selectedCoLoadIds = [];
            this.tempSelectedCoLoadIds = [];
            this.myPairedIds = [];
            this.getdatalist();
          } else {
            this.$message.error(res.msg || 'Failed to clear Co-Load nomination');
            this.lastConfirmedCoLoadIds = [];
            this.selectedCoLoadIds = [];
            this.tempSelectedCoLoadIds = [];
            this.myPairedIds = [];
          }
        } catch (err) {
          this.$message.error('Failed to clear Co-Load nomination');
          this.lastConfirmedCoLoadIds = [];
          this.selectedCoLoadIds = [];
          this.tempSelectedCoLoadIds = [];
          this.myPairedIds = [];
        }
        return;
      }

      const res = await getCoLoadNominations({ imo: this.bargeImo });
      const rows = res.data || [];

      // map: nominationId -> nomination row (has qty + eta)
      const idMap = new Map(rows.map(r => [Number(r.id), r]));

      const groupMap = {};
      const groupOptions = [];
      const singleOptions = [];

      for (const item of rows) {
        const id = Number(item.id);
        if (!id || id === currentId) continue;

        const isCoLoad = String(item.coLoad) === "1";
        const list = Array.isArray(item.coLoadList) ? item.coLoadList : [];

        // ✅ not co-loading -> normal single row
        if (!isCoLoad || list.length === 0) {
          singleOptions.push({
            value: this.makeSingleKey(id),
            label: `${item.id} • ${item.vesselName} • ${this.formatQty(item.nominatedQtyMax)} MT • ${item.noEta}`,
            id,
            vesselName: item.vesselName,
            nominatedQtyMax: item.nominatedQtyMax,
            noEta: item.noEta,
            coLoad: item.coLoad,
            coLoadList: item.coLoadList,
            type: 'single',
          });
          continue;
        }

        // ✅ coLoad group -> build from coLoadList IDs
        const mainId = Number(list[0].mainNomId);
        const memberIds = Array.from(
          new Set(list.map(x => Number(x.relatedNomId)).filter(Boolean))
        );

        // some APIs include mainId inside related list (yours does) — good.
        if (!memberIds.includes(mainId)) memberIds.unshift(mainId);

        const key = this.makeGroupKey(mainId, memberIds);

        // dedupe: both 1587 & 1590 will have same coLoadList, so only push once
        if (groupMap[key]) continue;

        const lbl = this.buildCoLoadGroupLabel(mainId, memberIds, idMap);

        groupOptions.push({
          value: key,
          label: lbl.plain,        // <-- single line (used by el-select)
          displayLabel: lbl.display, // <-- multiline (we render ourselves)
          mainId,
          memberIds,
          coLoad: 1,
          type: 'group',
        });
        groupMap[key] = { mainId, memberIds };


      }

      // store map for later use when user selects a group
      this.coLoadGroupMap = groupMap;

      // final options list: groups first, then singles
      this.coLoadNominationOptions = [...groupOptions, ...singleOptions];
      this.coLoadNominationIdMap = idMap;
    },

    formatToBackendDateTime(val) {
      if (!val) return null;
      if (typeof val === "number") {
        const m = moment(val);
        return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : null;
      }

      if (val instanceof Date) {
        const m = moment(val);
        return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : null;
      }

      if (typeof val === "string") {
        let m = moment(val, "DD/MM/YYYY HH:mm:ss", true);
        if (m.isValid()) return m.format("YYYY-MM-DD HH:mm:ss");

        m = moment(val, "YYYY-MM-DD HH:mm:ss", true);
        if (m.isValid()) return m.format("YYYY-MM-DD HH:mm:ss");

        m = moment(val);
        return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : null;
      }

      return null;
    },
    async onCoLoadDropdownVisibleChange(visible) {
      if (visible) {
        this.tempSelectedCoLoadKeys = [...(this.lastConfirmedCoLoadKeys || [])];
        return;
      }

      if (this.isApplyingCoLoad) return;

      const nextKeys = Array.isArray(this.tempSelectedCoLoadKeys) ? [...this.tempSelectedCoLoadKeys] : [];
      const prevKeys = Array.isArray(this.lastConfirmedCoLoadKeys) ? [...this.lastConfirmedCoLoadKeys] : [];

      const same =
        nextKeys.length === prevKeys.length &&
        nextKeys.every(k => prevKeys.includes(k));

      if (same) return;

      const currentId = Number(this.formData.id);

      const nextIds = this.expandKeysToIds(nextKeys, currentId);
      const prevIds = this.expandKeysToIds(prevKeys, currentId);

      if (prevIds.length > 0) {
        await this.confirmAndClearExistingCoLoad(prevIds);
        return;
      }
      if (nextIds.length > 0) {
        await this.confirmAndApplyCoLoad(nextIds, []);
      }
    },

    async confirmAndApplyCoLoad(nextIds, prevIds) {
      const currentId = Number(this.formData.id);

      const idMap = this.coLoadNominationIdMap || new Map();

      const nextLabels = nextIds
        .map(id => {
          const row = idMap.get(Number(id));
          if (!row) return `${id}`;
          return `• ${row.id} • ${row.vesselName} • ${this.formatQty(row.nominatedQtyMax)} MT • ${row.noEta}`;
        })
        .join('<br>');

      try {
        await this.$confirm(
          `Co-load this nomination (${currentId}) with:<br><br>${nextLabels}<br><br>Proceed?`,
          'Confirm Co-Load',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (e) {
        this.tempSelectedCoLoadIds = [];
        this.clearCoLoadUIState();
        return;
      }

      this.isApplyingCoLoad = true;
      const removedIds = prevIds.filter(id => !nextIds.includes(id));

      if (removedIds.length > 0) {
        const mainId = this.getPreviousCoLoadMainId();
        const relatedIds = this.getPreviousCoLoadRelatedIds();

        const res = await updateCoLoadStatus({
          coLoad: 0,
          mainId,
          relatedIds,
          noEta: null,
        });
      }

      try {
        const currentQty = Number(this.formData.nominatedQtyMax) || 0;

        const selectedItems = nextIds
          .map(id => idMap.get(Number(id)))
          .filter(Boolean);

        try {
          await this.clearExternalCoLoadsIfNeeded(selectedItems);
        } catch (e) {
          this.$message.error('Failed to clear existing co-load from selected nominations.');
          this.tempSelectedCoLoadIds = [...prevIds];
          this.isApplyingCoLoad = false;
          return;
        }

        let mainId = this.formData.id;
        let mainQty = currentQty;
        let mainEta = this.formData.noEtas || this.formData.noEta;

        for (const it of selectedItems) {
          const qty = Number(it.nominatedQtyMax) || 0;
          if (qty > mainQty) {
            mainQty = qty;
            mainId = Number(it.id);
            mainEta = it.noEta;
          }
        }

        const relatedIds = [currentId, ...nextIds].filter(id => Number(id) !== Number(mainId));
        const etaForBackend = this.formatToBackendDateTime(mainEta);

        if (!etaForBackend) {
          this.$message.error("ETA is invalid. Please re-select ETA.");
          this.tempSelectedCoLoadIds = [...prevIds];
          return;
        }

        const res = await updateCoLoadStatus({
          mainId,
          relatedIds,
          noEta: etaForBackend,
          coLoad: 1,
        });

        if (res.code === 200) {
          this.$message.success('Co-Load nomination updated successfully');

          this.selectedCoLoadIds = [...nextIds];
          this.lastConfirmedCoLoadIds = [...nextIds];
          this.myPairedIds = [...nextIds];
          this.lastConfirmedMainId = mainId;
          this.lastConfirmedCoLoadIds = [...nextIds];
          this.lastConfirmedCoLoadKeys = [...this.tempSelectedCoLoadKeys];

          this.tempSelectedCoLoadIds = [...nextIds];

          this.getdatalist();
        } else {
          this.$message.error(res.msg || 'Failed to update Co-Load nomination');
          this.tempSelectedCoLoadIds = [...prevIds];
        }
      } catch (err) {
        this.$message.error('Failed to update Co-Load nomination');
        this.tempSelectedCoLoadIds = [...prevIds];
      } finally {
        this.isApplyingCoLoad = false;
      }
    },
    async confirmAndClearExistingCoLoad(prevIds) {
      const currentId = Number(this.formData.id);

      const idMap = this.coLoadNominationIdMap || new Map();

      const prevLabels = prevIds
        .map(id => {
          const row = idMap.get(Number(id));
          return row
            ? `${row.id} • ${row.vesselName} • ${this.formatQty(row.nominatedQtyMax)} MT • ${row.noEta}`
            : `${id}`;
        })
        .join('<br>');

      try {
        await this.$confirm(
          `You are changing the co-load setup.\n\nThis will UNCO-LOAD all current nominations from (${currentId}):\n\n${prevLabels}\n\nAfter clearing, please select again.`,
          'Confirm Clear Co-Load',
          {
            confirmButtonText: 'Clear & Re-select',
            cancelButtonText: 'Cancel',
            type: 'warning',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (e) {
        // this.tempSelectedCoLoadIds = [...prevIds];
        this.clearCoLoadUIState();
        return;
      }

      this.isApplyingCoLoad = true;

      try {
        const mainId = this.getPreviousCoLoadMainId();
        const relatedIds = this.getPreviousCoLoadRelatedIds();

        this.coLoadData.mainId = mainId;
        this.coLoadData.relatedIds = relatedIds;
        this.coLoadData.noEta = null;

        const res = await updateCoLoadStatus({ ...this.coLoadData, coLoad: 0 });

        if (res.code === 200) {
          this.$message.success('Cleared co-load successfully. Please select again.');

          this.lastConfirmedCoLoadKeys = [];
          this.tempSelectedCoLoadKeys = [];
          this.selectedCoLoadList = [];

          this.coLoadGroupMap = {};
          this.coLoadNominationOptions = [];
          this.coLoadNominationIdMap = new Map();

          this.lastConfirmedMainId = null;

          this.coLoadData.coLoad = 1;

          this.getdatalist();
        } else {
          this.$message.error(res.msg || 'Failed to clear co-load');
          this.tempSelectedCoLoadIds = [...prevIds];
        }
      } catch (err) {
        this.$message.error('Failed to clear co-load');
        this.tempSelectedCoLoadIds = [...prevIds];
      } finally {
        this.isApplyingCoLoad = false;
      }
    },
    async onReSelectCoLoad() {
      const currentId = Number(this.formData.id);

      const idMap = this.coLoadNominationIdMap || new Map();

      // ✅ define prevIds FIRST
      const prevIds =
        (Array.isArray(this.lastConfirmedCoLoadIds) && this.lastConfirmedCoLoadIds.length
          ? this.lastConfirmedCoLoadIds
          : Array.isArray(this.myPairedIds)
            ? this.myPairedIds
            : []
        )
          .map(Number)
          .filter(Boolean);

      if (prevIds.length === 0) {
        // already empty, just reset UI
        this.coLoadData.coLoad = 0;
        this.clearCoLoadUIState();
        return;
      }

      const prevLabels = prevIds
        .map(id => {
          const row = idMap.get(Number(id));
          return row
            ? `• ${row.id} • ${row.vesselName} • ${this.formatQty(row.nominatedQtyMax)} MT • ${row.noEta}`
            : `${id}`;
        })
        .join('<br>');

      try {
        await this.$confirm(
          `This will clear co-load for nomination (${currentId}).<br><br>
       Current co-load nominations:<br><br>
       ${prevLabels}
       <br><br>Proceed?`,
          'Confirm Clear Co-Load',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
          }
        );
      } catch {
        return;
      }

      this.isApplyingCoLoad = true;

      try {
        const mainId = this.getPreviousCoLoadMainId();
        const relatedIds = this.getPreviousCoLoadRelatedIds();

        const res = await updateCoLoadStatus({
          coLoad: 0,
          mainId,
          relatedIds,
          noEta: null,
        });

        if (res.code === 200) {
          this.$message.success('Co-load cleared successfully.');

          this.coLoadData.coLoad = 0;
          this.clearCoLoadUIState();

          await this.getdatalist();
        } else {
          this.$message.error(res.msg || 'Failed to clear co-load');
        }
      } catch (err) {
        this.$message.error('Failed to clear co-load');
      } finally {
        this.isApplyingCoLoad = false;
      }
    },

    clearCoLoadUIState() {
      this.lastConfirmedCoLoadIds = [];
      this.selectedCoLoadIds = [];
      this.tempSelectedCoLoadIds = [];
      this.myPairedIds = [];

      this.lastConfirmedCoLoadKeys = [];
      this.tempSelectedCoLoadKeys = [];

      this.selectedCoLoadList = [];
      this.lastConfirmedMainId = null;
    },

    getPreviousCoLoadMainId() {
      const main = Number(this.lastConfirmedMainId);
      return main && !Number.isNaN(main) ? main : Number(this.formData.id);
    },

    getPreviousCoLoadRelatedIds() {
      const currentId = Number(this.formData.id);
      const mainId = this.getPreviousCoLoadMainId();

      const ids = Array.from(new Set([
        currentId,
        ...(Array.isArray(this.myPairedIds) ? this.myPairedIds.map(Number) : []),
        ...(Array.isArray(this.lastConfirmedCoLoadIds) ? this.lastConfirmedCoLoadIds.map(Number) : []),
      ])).filter(Boolean);

      return ids.filter(id => Number(id) !== Number(mainId));
    },
    extractCoLoadGroupFromOption(opt) {
      const list = Array.isArray(opt?.coLoadList) ? opt.coLoadList : [];
      if (!list.length) return null;

      const mainId = Number(list[0].mainNomId);
      if (!mainId) return null;

      // relatedNomId list usually includes main itself sometimes; remove it
      const relatedIds = Array.from(
        new Set(
          list
            .map(x => Number(x.relatedNomId))
            .filter(id => id && id !== mainId)
        )
      );

      return { mainId, relatedIds };
    },

    buildGroupKey(group) {
      if (!group) return '';
      const rel = (group.relatedIds || []).slice().map(Number).sort((a, b) => a - b);
      return `${Number(group.mainId)}::${rel.join(',')}`;
    },

    async clearExternalCoLoadsIfNeeded(selectedItems) {
      // selectedItems: mapped from nextIds -> coLoadNominationOptions entries
      // Only clear if the target nomination is already co-loading (coLoad == 1) AND has coLoadList
      const targets = (selectedItems || []).filter(it => String(it.coLoad) === "1");

      if (!targets.length) return;

      // dedupe by group (important if user picks 2 nominations from same existing group)
      const groupsMap = new Map();

      for (const opt of targets) {
        const grp = this.extractCoLoadGroupFromOption(opt);
        if (!grp) continue;

        const key = this.buildGroupKey(grp);
        if (!key) continue;

        groupsMap.set(key, grp);
      }

      const groups = Array.from(groupsMap.values());
      if (!groups.length) return;

      // 🔥 Clear each external group
      for (const grp of groups) {
        await updateCoLoadStatus({
          coLoad: 0,
          mainId: grp.mainId,
          relatedIds: grp.relatedIds,
          noEta: null,
        });
      }
    },

    formatQty(qty) {
      const n = Number(qty);
      if (Number.isNaN(n)) return '-';
      return n.toLocaleString(undefined, { maximumFractionDigits: 6 });
    },

    makeGroupKey(mainId, ids) {
      const sorted = (ids || []).map(Number).filter(Boolean).sort((a, b) => a - b);
      return `GROUP:${Number(mainId)}:${sorted.join(',')}`;
    },

    makeSingleKey(id) {
      return `SINGLE:${Number(id)}`;
    },

    buildCoLoadGroupLabel(mainId, memberIds, idMap) {
      const ids = (memberIds || [])
        .map(Number)
        .filter(Boolean)
        .sort((a, b) => a - b);

      const lines = ids.map(id => {
        const row = idMap.get(Number(id));
        const qtyTxt = row ? `${this.formatQty(row.nominatedQtyMax)} MT` : '-';
        const etaTxt = row ? (row.noEta || '-') : '-';
        const vesselTxt = row ? row.vesselName : '-';
        return `${id} • ${vesselTxt} • ${qtyTxt} • ${etaTxt}`;
      });

      return {
        plain: lines.join('\n'),
        display: lines.join('\n'),
      };
    },

    expandKeysToIds(keys, currentId) {
      const out = new Set();

      (keys || []).forEach(k => {
        const key = String(k);

        if (key.startsWith('SINGLE:')) {
          out.add(Number(key.slice('SINGLE:'.length)));
          return;
        }

        if (key.startsWith('GROUP:')) {
          const grp = this.coLoadGroupMap[key];
          // ✅ your groupMap stores { mainId, memberIds }
          (grp?.memberIds || []).forEach(id => out.add(Number(id)));
          return;
        }
      });

      out.delete(Number(currentId)); // exclude myself
      return Array.from(out).filter(Boolean);
    },

    formatGroupMemberText(x) {
      // x could be { relatedNomId, nominatedQtyMax, noEta } OR other naming
      const id =
        Number(x.relatedNomId ?? x.nominationId ?? x.id ?? x.relatedId);

      const qty = x.nominatedQtyMax ?? x.qty ?? x.nominated_qty_max;
      const eta = x.noEta ?? x.eta ?? x.no_eta;

      const qtyTxt = (qty !== undefined && qty !== null && qty !== '')
        ? `${qty} MT`
        : '-';

      const etaTxt = (eta !== undefined && eta !== null && eta !== '')
        ? `${eta}`
        : '-';

      return `${id}(${qtyTxt}, ${etaTxt})`;
    },

    hashToHue(str) {
      let h = 0;
      for (let i = 0; i < str.length; i++) {
        h = (h * 31 + str.charCodeAt(i)) >>> 0;
      }
      return h % 360;
    },

    colorFromKey(key) {
      // nice “random” colors with consistent saturation/lightness
      const hue = this.hashToHue(String(key));
      return `hsl(${hue} 79% 48%)`;
    },

    ensureCoLoadColor(key) {
      const k = String(key);
      if (!this.coLoadColorMap[k]) {
        this.coLoadColorMap[k] = this.colorFromKey(k);
      }
      return this.coLoadColorMap[k];
    },

    getOptionDotColor(option) {
      if (!option) return '#999';

      if (option.type === 'group') {
        return this.ensureCoLoadColor(option.value);
      }

      return this.ensureCoLoadColor(`SINGLE:${option.id || option.value}`);
    },

    isLockedPriority(v) {
      const n = Number(v);
      return n === 1 || n === 2;
    },

    onPriorityStatusChange(val) {
      const n = Number(val);

      // Block selecting 1 or 2 forever
      if (n === 1 || n === 2) {
        this.$message.warning("Priority Status 1 and 2 cannot be selected manually.");
        // revert back
        this.$nextTick(() => {
          this.formData.priorityStatus = null;
        });
        return;
      }

      // normal flow
      this.handleUpdatePriorityStatus();
    },
  },
};
</script>

<style lang="scss" scoped>
.containerForm {
  padding: 10px 26px;
  background: #fff;

  .head {
    padding-bottom: 6px;
    border-bottom: 1px solid #d5dded;

    >.fileIcon {
      font-size: 20px;
    }

    >p {
      color: #4c565c;
      margin-left: 18px;
      font-size: 13px;
    }
  }

  .form {
    margin-top: 10px;
  }
}

::v-deep.bargeNameinput {
  width: 100%;

  .el-input__inner {
    color: #2e5efd !important;
  }
}

::v-deep .el-form-item--medium .el-form-item__label {
  color: #82889c;
  font-size: 12px;
}

::v-deep .el-input-group__append {
  background: #82889c;
  border-radius: 0px 1px 1px 0px;
  font-size: 12px;
  text-align: center;

  color: #ffffff;
}

::v-deep .el-switch {
  transform: scale(1.2);
}

.information {
  margin-top: 30px;

  .head {
    display: flex;
    align-items: flex-end;
    padding-bottom: 8px;
    border-bottom: 1px solid #d5dded;
  }

  .svg-icon {
    width: 38px;
    height: 22px;
  }

  .title {
    color: #4c565c;
    margin-left: 9px;
    font-size: 13px;
  }
}

.formItemText {
  font-size: 12px;
  color: #82889c;
}

::v-deep .el-input--small .el-input__inner {
  height: 28px;
}

::v-deep .el-input--small textarea {
  height: 60px !important;
  min-height: 60px !important;
}

.typeOfPilot {
  position: relative;

  .text {
    width: 100%;
    font-size: 10px;
    color: #ff0000;

    .textb {
      line-height: 14px;
    }
  }
}

::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 5px;
}

::v-deep .el-form-item--small .el-form-item__label {
  line-height: 28px;
}

::v-deep .el-form-item__error {
  color: transparent;
}

::v-deep .formItemHideFromTerminal {
  .el-form-item__content {
    margin-left: 0 !important;

    .el-checkbox__label {
      font-weight: normal;
    }
  }
}

::v-deep .vue-tel-input.disabled {
  background-color: #f5f7fa !important;
}

::v-deep .vue-tel-input.disabled input {
  background-color: #f5f7fa !important;
}

.option-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.option-left {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.option-right {
  color: #8b8f99;
  font-size: 12px;
  margin-left: 8px;
  flex-shrink: 0;
}

::v-deep .vs__search::placeholder {
  color: #9aa0a6 !important;
  font-size: 12px !important;
  opacity: 1;
}

::v-deep .vs__search {
  font-size: 12px !important;
}

::v-deep .vs__selected {
  background-color: #e6f0ff !important;
  border: 1px solid #409EFF !important;
  color: #2c3e50 !important;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: pre-line;
}

::v-deep .vs__deselect {
  fill: #409EFF !important;
}

::v-deep .vs__dropdown-option--highlight {
  background-color: #ecf5ff !important;
  color: #409EFF !important;
}

::v-deep .vs__dropdown-option--selected {
  background-color: #e6f0ff !important;
  color: #409EFF !important;
  font-weight: 500;
}

::v-deep .coLoadOptionBlock {
  white-space: pre-line !important;
  line-height: 30px;
  font-size: 14px;
}

::v-deep .vs__dropdown-option {
  white-space: normal !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

::v-deep .vs__dropdown-toggle {
  padding: 2px 6px !important; // top/bottom 4px, left/right 8px
  min-height: 30px; // optional: slightly taller
}
</style>